/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-template */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-return-assign */
/* eslint-disable operator-assignment */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-use-before-define */
/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unneeded-ternary */
import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import subYears from 'date-fns/subYears';
import { Accordion, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {
  MdClose,
  MdOutlineCreditCard,
  MdOutlineFastfood,
  MdLuggage,
  MdList,
  MdChair,
  MdCheckCircleOutline,
  MdCheckCircle,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
} from 'react-icons/md';
import { CiWallet, CiBank } from 'react-icons/ci';
import { IoMdEyeOff, IoMdEye } from 'react-icons/io';
import { useLocation, useNavigate } from 'react-router-dom';
import AppLink from '../../shared/components/app-link/AppLink';
import '../flights/FlightBookingPage.scss';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppSelect from '../../shared/components/app-select/AppSelect';
import { getAgentBalanceApi } from '../../api/profileApi';
import {
  getObjectFromLS,
  getUserAgentId,
} from '../../shared/helper-utils/localStorage';
import {
  API_DATE_FORMAT,
  // DATE_MONTH_YEAR_VIEW_FORMAT,
  DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
  NAVIGATION_ROUTES,
  TODAY_DATE,
} from '../../shared/constants/Constants';
import AppButton from '../../shared/components/app-button/AppButton';
import {
  getSeatLayoutApi,
  getSSRApi,
  bookFlightApi,
  getFareRulesApi,
  HoldFlightApi,
  savePaxDetailsApi,
  chooseCustomerApi,
} from '../../api/flightApi';
import {
  formatCurrency,
  formatDate,
  scrollToTop,
  removeAlignLogoINBookingPgae,
  alignLogoInBookingPage,
  hideHeaderFooter,
  showHeaderFooter,
  isMobileWidth,
  getDateWithHypends,
  getNewDate,
} from '../../shared/helper-utils/appUtils';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import SelectedFlightDetails from '../one-way/SelectedFlightDetails';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import CountdownTimer from '../../shared/components/countdown-timer/CountdownTimer';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import AppModal from '../../shared/components/app-modal/AppModal';
import { countryMobileCodes } from '../../shared/constants/CountryOptions';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';
import AppSidebar from '../../shared/components/app-sidebar/AppSidebar';
import GdsMeals from '../../shared/constants/GdsMeals';
import { APP_USER_PROFILE } from '../../saas/AppStorageStaticNames';

const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const NAME_REGEX = /^[a-zA-Z ]*$/;
const GST_REGEX = /^[a-zA-Z0-9]*$/;

const getLabel = (country) => {
  return (
    <div className="d-flex justify-content-between align-items-center p-1">
      <span className="fs-14">{country.dial_code}</span>
      <div>
        <img
          style={{ width: '17px', height: '15px' }}
          src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/${country.code.toLowerCase()}.svg`}
          alt={country.code}
        />
      </div>
    </div>
  );
};

const mobileCodes = countryMobileCodes.map((country) => ({
  label: getLabel(country),
  value: country.dial_code,
}));

const FLIGHT_DETAILS = 'flight-deatils';
const INSURANCE = 'insurance';
const PAX = 'travellers';
const SSR = 'ssr';
const PG = 'pg';

function FlightDomMultiCityBookingPage() {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const navigate = useNavigate();
  const { state } = useLocation();
  const {
    selectedFlight,
    selectedFare,
    searchRequest,
    rePriceResponse,
    journeyType,
    selectedFareKeys,
    domInt,
  } = state;

  const [acceptTerms, setAcceptTerms] = useState(false);
  const ELEVEN_MIN_IN_MILLI_SECS = 11 * 60 * 1000;
  const NOW_IN_MILLI_SECS = getNewDate(TODAY_DATE).getTime();
  const [elevenMinFromNowInMilli] = useState(
    NOW_IN_MILLI_SECS + ELEVEN_MIN_IN_MILLI_SECS,
  );
  const [wheelChairSsr, setWheelChairSsr] = useState({});
  const [alert, setAlert] = useState(undefined);
  const [showSpecialAssistance, setShowSpecialAssistance] = useState(false);
  const selectedTravellerRef = useRef(undefined);
  const fareSummaryRef = useRef({});
  const selectedSpecialAssistanceIndexRef = useRef(-1);
  const isApiRequestProcessingRef = useRef(false);
  const flightLegsWithSeatsRef = useRef({});
  const flightLegsWithBaggageRef = useRef({});
  const flightLegsWithMealRef = useRef({});
  const flightLegsWithSpecialSsr = useRef({});
  const FlightLegsWithSpecialAssistanceRef = useRef({});
  const [userSelectedSsrRows, setUserSelectedSsrRows] = useState({});
  const [travellers, setTravellers] = useState([]);
  const [showSpecialSsr, setShowSpecialSsr] = useState(false);
  const [showBagTermsDialog, setShowBagTermsDialog] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [showConfirmHoldDialog, setShowConfirmHoldDialog] = useState(false);
  const [gst, setGst] = useState({
    gstnumber: '',
    gstcompany: '',
    gstemail: '',
  });
  const [gstValidationError, setGstValidationError] = useState(false);
  const [countryCodeOptions] = useState(mobileCodes);
  const walletBalanceRef = useRef(0);
  const [countryCode, setCountryCode] = useState('+91');
  const [leadmobile, setLeadmobile] = useState('');
  const [leademail, setLeademail] = useState('');
  const [showMeals, setShowMeals] = useState(false);
  const [showBaggage, setShowBaggage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activeSeatIndex, setActiveSeatIndex] = useState(0);
  const [activeBagIndex, setActiveBagIndex] = useState(0);
  const [activeMealIndex, setActiveMealIndex] = useState(0);
  const [activeSsrIndex, setActiveSsrIndex] = useState(0);
  const [isSeatEditMode, setIsSeatEditMode] = useState(false);
  const [isBagEditMode, setIsBagEditMode] = useState(false);
  const [isMealEditMode, setIsMealEditMode] = useState(false);
  const [isSpecialSSREditMode, setIsSpecialSSREditMode] = useState(false);
  const [isMealSelected, setIsMealSelected] = useState(false);
  const [isSeatSelected, setIsSeatSelected] = useState(false);
  const [isBaggageSelected, setIsBaggageSelected] = useState(false);
  const [isSpecialSsrSelected, setIsSpecialSsrSelected] = useState(false);
  const [seatSelectionSector, setSeatSelectionSector] = useState('');
  const [mealSelectionSector, setMealSelectionSector] = useState('');
  const [baggageSelectionSector, setBaggageSelectionSector] = useState('');
  const [specialSsrSelectionSector, setSpecialSsrSelectionSector] =
    useState('');
  const [
    specialAssistanceSelectionSector,
    setSpecialAssistanceSelectionSector,
  ] = useState('');
  const [isBookingClicked, setIsBookingClicked] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [hasWheelChairRows, setHasWheelChairRows] = useState(false);
  const hasSeatMapRef = useRef(false);
  const hasSsrRef = useRef(false);
  const [showSeatMap, setShowSeatMap] = useState(false);
  const [fareRulesHtml, setFareRulesHtml] = useState('');
  const [isOpenFareRulesDialog, setIsOpenFareRulesDialog] = useState(false);
  const [hasTravelInsurance, setHasTravelInsurance] = useState(false);
  const [showFlightDetails, setShowFlightDetails] = useState(true);
  const [paymentmode, setPaymentMode] = useState('cashcard');
  const [eligiblePaxForTravelInsurance, setEligiblePaxForTravelInsurance] =
    useState(0);
  const [additionalMarkup, setAdditionalMarkup] = useState(0);
  const [showMarkup, setShowMarkup] = useState(false);
  const [tempMarkupList, setTempMarkupList] = useState([]);
  const [showNetFare, setShowNetFare] = useState(false);
  const [activeTab, setActiveTab] = useState(FLIGHT_DETAILS);
  const [isFlightDetailsCompleted, setIsFlightDetailsCompleted] =
    useState(false);
  const [isInusranceCompleted, setIsInsuranceCompleted] = useState(false);
  const [isPaxCompleted, setIsPaxCompleted] = useState(false);
  const [isSSRCompleted, setIsSSRCompleted] = useState(false);
  const [isPgCompleted, setIsPgCompleted] = useState(false);
  const targetRefs = {
    flightDetails: useRef(null),
    insurance: useRef(null),
    pax: useRef(null),
    ssr: useRef(null),
    pg: useRef(null),
  };
  const flightSectorsRef = useRef([]);
  const onwardFlightSectorsRef = useRef([]);
  const [isGdsSearch, setIsGdsSearch] = useState(false);
  const [isSeriesFare, setIsSeriesFare] = useState(false);
  const [isPassThrough, setIsPassthrough] = useState(false);
  const [onwardPassThroughId, setOnwardPassThroughId] = useState(0);
  const [returnPassThroughId, setReturnPassThroughId] = useState(0);
  const [savedPaxIndex, setSavedPaxIndex] = useState([]);
  const [flightBookingResponse, setFlightBookingResponse] = useState([]);
  const [showPostBookingPopup, setShowPostBookingPopup] = useState(false);
  const searchArrayRef = useRef([]);
  const journeySectorsRef = useRef([]);
  const [showSelectPaxModal, setShowSelectPaxModal] = useState(false);
  const [customers, setCustomers] = useState([]);
  const selectedCustomerRef = useRef(undefined);
  const [profileName, setProfileName] = useState('');

  const TITLE_OPTIONS = [
    { label: formattedMessage('mr'), value: 'Mr' },
    { label: formattedMessage('ms'), value: 'Ms' },
    { label: formattedMessage('mrs'), value: 'Mrs' },
  ];
  const OTHER_TITLE_OPTIONS = [
    { label: formattedMessage('mstr'), value: 'Mstr' },
    { label: formattedMessage('ms'), value: 'Ms' },
  ];
  const GENDER_OPTIONS = [
    { label: 'Male', value: 'M' },
    { label: 'Female', value: 'F' },
  ];

  const JOURNEY_TYPES = {
    ONWARD: 'onward',
    RETURN: 'return',
    ROUND_TRIP: 'roundtrip',
    ONE_WAY: 'oneway',
  };

  const tripTypeDict = {
    OneWay: 'oneway_btn',
    RoundTrip: 'roundtrip_btn',
  };

  const ADDONS = {
    MEALS: 'meals',
    BAGGAGE: 'baggage',
    SPECIAL_SSR: 'special_ssr',
    SEAT: 'seat',
  };

  useEffect(() => {
    alignLogoInBookingPage();
    return () => removeAlignLogoINBookingPgae();
  }, []);

  const getWaterMark = () => {
    let dataWatermark = getUserAgentId();
    dataWatermark = (dataWatermark + ' ').repeat(100);
    return dataWatermark;
  };

  const getDesignatorForSeat = (seat) => {
    const isEmpty = seat.additionalinfo.indexOf('no-seat') > -1;
    const isUnavailable = seat.seatstatus.toLowerCase().indexOf('open') === -1;
    if (isEmpty) {
      return '';
    }
    if (isUnavailable) {
      return 'X';
    }
    return seat.seatdesignator;
  };

  const getSeatToolTipText = (seat) => {
    const isEmpty = seat.additionalinfo.indexOf('no-seat') > -1;
    const isUnavailable = seat.seatstatus.toLowerCase().indexOf('open') === -1;
    if (isEmpty) {
      return '';
    }
    if (isUnavailable) {
      return 'This seat is unavailable';
    }
    return (
      <>
        <span>{formatCurrency(seat.seatprice)}</span>
        <span>{seat.additionalinfo.replace('margin-left', '')}</span>
      </>
    );
  };

  const groupSeatMapByFlightLeg = (SeatMap, tripNumber) => {
    const seatMapArr = Array.isArray(SeatMap) ? SeatMap : [SeatMap];
    seatMapArr.forEach((seatMap) => {
      const sector = `${seatMap.origin} - ${seatMap.destination} - ${tripNumber}`;
      const { seatrows } = seatMap;
      if (seatrows !== '') {
        const seatsArray = Array.isArray(seatrows.SeatRow)
          ? seatrows.SeatRow
          : [seatMap.SeatRow];
        const digitArr = [];
        const letterArr = [];
        const aisleRows = {};
        const uniqueAisleRows = [];
        seatsArray.forEach((x) => {
          if (x.seatdesignator !== '' && x.seatdesignator.indexOf('$') === -1) {
            const digit = x.seatdesignator.replace(/\D/g, '');
            const letter = x.seatdesignator.replace(/[^a-z]/gi, '');
            const isAisle =
              x.additionalinfo
                .toLowerCase()
                .split(',')
                .some(
                  (k) =>
                    k.indexOf('aisle') > -1 &&
                    k.indexOf('not') === -1 &&
                    k.indexOf('false') === -1,
                ) || x.seattype === 'Aisle';
            if (isAisle && letter !== undefined && letter !== '') {
              if (aisleRows[letter] === undefined) {
                aisleRows[letter] = 1;
              } else {
                aisleRows[letter] += aisleRows[letter];
                if (
                  aisleRows[letter] > 2 &&
                  uniqueAisleRows.indexOf(letter) === -1
                ) {
                  uniqueAisleRows.push(letter);
                }
              }
            }

            if (
              digit !== undefined &&
              letter !== '' &&
              digitArr.indexOf(digit) === -1
            ) {
              digitArr.push(digit);
            }
            if (
              letter !== undefined &&
              letter !== '' &&
              letterArr.indexOf(letter) === -1
            ) {
              letterArr.push(letter);
            }
          }
        });
        letterArr.sort((a, b) => (a < b ? -1 : 1));
        uniqueAisleRows.sort((a, b) => (a < b ? -1 : 1));
        const filteredaisleRows = uniqueAisleRows.filter(
          (_, index) => index % 2 === 0,
        );
        digitArr.sort((a, b) => Number(a) < Number(b));
        digitArr.forEach((digitNum, digitIndex) => {
          letterArr.forEach((letterNum, letterIndex) => {
            const seatNum = `${digitNum}${letterNum}`;
            const isPresent = seatsArray.find((x) => {
              const digit = x.seatdesignator.replace(/\D/g, '');
              const letter = x.seatdesignator.replace(/[^a-z]/gi, '');
              return `${digit}${letter}` === seatNum;
            });
            if (!isPresent) {
              const noSeat = {
                additionalinfo: 'no-seat',
                columnnum: '',
                height: 2,
                paxseatprices: '',
                premiumseat: '',
                rownum: '',
                seatdesignator: seatNum,
                seatgroup: 98,
                seatprice: '',
                seatstatus: '',
                seattype: 'NS',
                width: 2,
                xval: 1,
                yval: 6,
              };
              seatsArray.push(noSeat);
            }
          });
        });
        const seatMapDict = seatsArray.filter(
          (x) => x.seatdesignator.indexOf('$') === -1,
        );
        seatMapDict.forEach((x) => {
          const letter = x.seatdesignator.replace(/[^a-z]/gi, '');
          if (filteredaisleRows.indexOf(letter) > -1) {
            x.additionalinfo += `,margin-left`;
          }
        });
        const result = {};

        // Initialize the result object with empty arrays for each digit
        digitArr.forEach((digit) => {
          result[digit] = [];
        });

        // Iterate over the array of objects and group them by digit
        seatMapDict.forEach((seatObj) => {
          const match = seatObj.seatdesignator.match(/(\d+)-?(\w+)/); // Extract the numeric part and the letter part of the seat
          if (match) {
            const digit = parseInt(match[1], 10);
            if (result[digit]) {
              result[digit].push(seatObj);
            }
          }
        });

        // Sort the seats within each digit group alphabetically by seat string
        Object.values(result).forEach((seatGroup) => {
          seatGroup.sort((a, b) =>
            a.seatdesignator.localeCompare(b.seatdesignator),
          );
        });
        flightLegsWithSeatsRef.current[sector] = {
          seats: result,
          seatDigitArray: digitArr,
          seatLetterArray: letterArr,
        };
        const obj = flightLegsWithSeatsRef.current;
        const sortedKeys = Object.keys(obj).sort((key1, key2) => {
          const tripNumber1 = parseInt(key1.split(' - ').pop(), 10);
          const tripNumber2 = parseInt(key2.split(' - ').pop(), 10);
          return tripNumber1 - tripNumber2;
        });
        const sortedObj = {};
        sortedKeys.forEach((key) => {
          sortedObj[key] = obj[key];
        });
        flightLegsWithSeatsRef.current = sortedObj;
      }
    });
  };

  const getSeatLayout = async () => {
    const userProfile = getObjectFromLS(APP_USER_PROFILE);
    let count = 0;
    searchArrayRef.current.forEach(async (sec, index) => {
      const response = await getSeatLayoutApi(
        userProfile.agentId,
        JOURNEY_TYPES.ONWARD,
        rePriceResponse[sec].bookingkey,
        rePriceResponse[sec].domint,
      );
      count += 1;
      if (
        response &&
        response.Root &&
        response.Root.Result !== null &&
        response.Root.Result.list
      ) {
        const { SeatMap } = response.Root.Result.list;
        groupSeatMapByFlightLeg(SeatMap, index);
        const sectors = Object.keys(flightLegsWithSeatsRef.current);
        setSeatSelectionSector(sectors[0]);
        setActiveSeatIndex(0);
      }
      if (count === searchArrayRef.current.length) {
        setShowSeatMap(true);
        setIsLoading(false);
      }
    });
  };

  const groupBySsrType = (response, type, tripNumber) => {
    if (
      response &&
      response.list &&
      response.list !== null &&
      response.list !== ''
    ) {
      const { CarrierSSR } = response.list;
      const list = Array.isArray(CarrierSSR) ? CarrierSSR : [CarrierSSR];
      const groupedBySector = list.reduce((acc, cur) => {
        if (cur.ArrStation) {
          cur.origin = cur.DepStation;
          cur.destination = cur.ArrStation;
        }
        if (
          (cur.origin !== 'all' &&
            cur.origin !== '' &&
            cur.origin !== undefined) ||
          (cur.destination !== 'all' &&
            cur.destination !== '' &&
            cur.destination !== undefined)
        ) {
          const key = `${cur.origin} - ${cur.destination} - ${tripNumber}`;
          if (acc[key]) {
            acc[key].push(cur);
          } else {
            acc[key] = [cur];
          }
        }
        return acc;
      }, {});
      const sectors = Object.keys(groupedBySector);
      sectors.forEach((sector) => {
        const groupedData = groupedBySector[sector].reduce((acc, cur) => {
          if (acc[cur.ssrtype]) {
            acc[cur.ssrtype].push(cur);
          } else {
            acc[cur.ssrtype] = [cur];
          }
          return acc;
        }, {});
        if (groupedData.meal !== undefined) {
          groupedData.meal.sort(
            (meal1, meal2) => meal1.chargeableamount - meal2.chargeableamount,
          );
          flightLegsWithMealRef.current[sector] = groupedData.meal;
          const obj = flightLegsWithMealRef.current;
          const sortedKeys = Object.keys(obj).sort((key1, key2) => {
            const tripNumber1 = parseInt(key1.split(' - ').pop(), 10);
            const tripNumber2 = parseInt(key2.split(' - ').pop(), 10);
            return tripNumber1 - tripNumber2;
          });
          const sortedObj = {};
          sortedKeys.forEach((key) => {
            sortedObj[key] = obj[key];
          });
          flightLegsWithMealRef.current = sortedObj;
          if (Object.keys(flightLegsWithMealRef.current).length > 0) {
            setMealSelectionSector(
              Object.keys(flightLegsWithMealRef.current)[0],
            );
          }
        }
        if (groupedData.baggage !== undefined) {
          groupedData.baggage.sort(
            (baggage1, baggage2) =>
              baggage1.chargeableamount - baggage2.chargeableamount,
          );
          flightLegsWithBaggageRef.current[sector] = groupedData.baggage;
          const obj = flightLegsWithBaggageRef.current;
          const sortedKeys = Object.keys(obj).sort((key1, key2) => {
            const tripNumber1 = parseInt(key1.split(' - ').pop(), 10);
            const tripNumber2 = parseInt(key2.split(' - ').pop(), 10);
            return tripNumber1 - tripNumber2;
          });
          const sortedObj = {};
          sortedKeys.forEach((key) => {
            sortedObj[key] = obj[key];
          });
          flightLegsWithBaggageRef.current = sortedObj;
          if (Object.keys(flightLegsWithBaggageRef.current).length > 0) {
            setBaggageSelectionSector(
              Object.keys(flightLegsWithBaggageRef.current)[0],
            );
          }
        }

        if (groupedData.specialssr !== undefined) {
          const speicalSsrList = groupedData.specialssr.filter(
            (ssr) => ['WCHS', 'WCHR', 'WCHC'].indexOf(ssr.ssrcode) === -1,
          );
          const specialAssistance = groupedData.specialssr.filter(
            (ssr) => ['WCHS', 'WCHR', 'WCHC'].indexOf(ssr.ssrcode) > -1,
          );
          if (specialAssistance.length > 0) {
            setHasWheelChairRows(true);
          }
          speicalSsrList.sort(
            (baggage1, baggage2) =>
              baggage1.chargeableamount - baggage2.chargeableamount,
          );
          flightLegsWithSpecialSsr.current[sector] = speicalSsrList;
          const obj = flightLegsWithSpecialSsr.current;
          const sortedKeys = Object.keys(obj).sort((key1, key2) => {
            const tripNumber1 = parseInt(key1.split(' - ').pop(), 10);
            const tripNumber2 = parseInt(key2.split(' - ').pop(), 10);
            return tripNumber1 - tripNumber2;
          });
          const sortedObj = {};
          sortedKeys.forEach((key) => {
            sortedObj[key] = obj[key];
          });
          flightLegsWithSpecialSsr.current = sortedObj;
          FlightLegsWithSpecialAssistanceRef.current[sector] =
            specialAssistance;
          if (Object.keys(flightLegsWithSpecialSsr.current).length > 0) {
            setSpecialSsrSelectionSector(
              Object.keys(flightLegsWithSpecialSsr.current)[0],
            );
          }
          if (
            Object.keys(FlightLegsWithSpecialAssistanceRef.current).length > 0
          ) {
            setSpecialAssistanceSelectionSector(
              Object.keys(FlightLegsWithSpecialAssistanceRef.current)[0],
            );
          }

          const wcssr = { ...wheelChairSsr };
          wcssr[sector] = {};
          setWheelChairSsr(wcssr);
        }
      });
    } else {
      const eligiblesector = [];
      if (type === 'onward') {
        onwardFlightSectorsRef.current.forEach((sec) => {
          const secOrigin = sec.split(' - ')[0];
          const secDestination = sec.split(' - ')[1];
          const isGds = false;
          if (isGds) {
            eligiblesector.push(sec);
          }
        });
      }
      if (eligiblesector.length > 0) {
        eligiblesector.forEach((sector) => {
          const res = GdsMeals();
          res.forEach((meal) => {
            meal.origin = sector.split(' - ')[0];
            meal.destination = sector.split(' - ')[1];
          });
          flightLegsWithMealRef.current[sector] = res;
        });
        if (Object.keys(flightLegsWithMealRef.current).length > 0) {
          setMealSelectionSector(Object.keys(flightLegsWithMealRef.current)[0]);
        }
      }
    }
  };

  const getSSRLayout = async (addOnType) => {
    let count = 0;
    searchArrayRef.current.forEach(async (sec, index) => {
      const response = await getSSRApi(
        rePriceResponse[sec].bookingkey,
        JOURNEY_TYPES.ONWARD,
      );
      count += 1;
      groupBySsrType(response, 'onward', index);
      if (count === searchArrayRef.current.length) {
        setIsLoading(false);
        if (addOnType === ADDONS.MEALS) {
          setActiveMealIndex(0);
          setShowMeals(true);
        } else if (addOnType === ADDONS.BAGGAGE) {
          setActiveBagIndex(0);
          setShowBaggage(true);
        } else if (addOnType === ADDONS.SPECIAL_SSR) {
          setActiveSsrIndex(0);
          setShowSpecialSsr(true);
        }
      }
    });
  };

  useEffect(() => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    travellers.forEach((traveller, index) => {
      Object.keys(userSelectedSsrRowsTemp).forEach((sector) => {
        userSelectedSsrRowsTemp[sector].baggageRows[index].passenger_fname =
          traveller.first_name;
        userSelectedSsrRowsTemp[sector].baggageRows[index].passenger_lname =
          traveller.last_name;
        userSelectedSsrRowsTemp[sector].baggageRows[index].passenger_title =
          traveller.title;
        userSelectedSsrRowsTemp[sector].mealRows.forEach((mealRow) => {
          if (mealRow.travellerIndex === index) {
            mealRow.passenger_fname = traveller.first_name;
            mealRow.passenger_lname = traveller.last_name;
            mealRow.passenger_title = traveller.title;
          }
        });
        userSelectedSsrRowsTemp[sector].seatRows[index].passenger_fname =
          traveller.first_name;
        userSelectedSsrRowsTemp[sector].seatRows[index].passenger_lname =
          traveller.last_name;
        userSelectedSsrRowsTemp[sector].seatRows[index].passenger_title =
          traveller.title;
        userSelectedSsrRowsTemp[sector].specialSsrRows[index].passenger_fname =
          traveller.first_name;
        userSelectedSsrRowsTemp[sector].specialSsrRows[index].passenger_lname =
          traveller.last_name;
        userSelectedSsrRowsTemp[sector].specialSsrRows[index].passenger_title =
          traveller.title;
        userSelectedSsrRowsTemp[sector].specialAssistanceRows[
          index
        ].passenger_fname = traveller.first_name;
        userSelectedSsrRowsTemp[sector].specialAssistanceRows[
          index
        ].passenger_lname = traveller.last_name;
        userSelectedSsrRowsTemp[sector].specialAssistanceRows[
          index
        ].passenger_title = traveller.title;
      });
    });
  }, [travellers]);

  const getSpecialSsrRows = (list, flightLeg, jtype) => {
    return list.map((traveller, index) => ({
      flightNumber: flightLeg.flightnumber,
      carrier: flightLeg.carrier,
      destination: flightLeg.destination,
      jtype,
      origin: flightLeg.origin,
      passenger_fname: traveller.first_name,
      passenger_lname: traveller.last_name,
      passenger_title: traveller.title,
      paxid: '',
      paxtype: traveller.type,
      ssr_chargeableamount: '',
      ssrcode: '',
      ssrname: '',
      ssrtype: 'specialssr',
      travellerIndex: index,
    }));
  };

  const getBaggageSsrRows = (list, flightLeg, jtype) => {
    return list.map((traveller, index) => ({
      flightNumber: flightLeg.flightnumber,
      carrier: flightLeg.carrier,
      destination: flightLeg.destination,
      jtype,
      origin: flightLeg.origin,
      passenger_fname: traveller.first_name,
      passenger_lname: traveller.last_name,
      passenger_title: traveller.title,
      paxid: '',
      paxtype: traveller.type,
      ssr_chargeableamount: '',
      ssrcode: '',
      ssrname: '',
      ssrtype: 'baggage',
      travellerIndex: index,
    }));
  };

  const getMealSsrRows = (list, flightLeg, jtype) => {
    return list.map((traveller, index) => ({
      flightNumber: flightLeg.flightnumber,
      carrier: flightLeg.carrier,
      destination: flightLeg.destination,
      jtype,
      origin: flightLeg.origin,
      passenger_fname: traveller.first_name,
      passenger_lname: traveller.last_name,
      passenger_title: traveller.title,
      paxid: '',
      paxtype: traveller.type,
      ssr_chargeableamount: '',
      ssrcode: '',
      ssrname: '',
      ssrtype: 'meal',
      travellerIndex: index,
    }));
  };

  const getSeatSsrRows = (list, flightLeg, jtype) => {
    return list.map((traveller) => ({
      flightNumber: flightLeg.flightnumber,
      carrier: flightLeg.carrier,
      destination: flightLeg.destination,
      jtype,
      origin: flightLeg.origin,
      passenger_fname: traveller.first_name,
      passenger_lname: traveller.last_name,
      passenger_title: traveller.title,
      paxid: '',
      paxtype: traveller.type,
      ssr_chargeableamount: '',
      ssrcode: '',
      ssrname: '',
      ssrtype: 'seat',
    }));
  };

  const getSpecialAssistanceRows = (list, flightLeg, jtype) => {
    return list.map((traveller, index) => ({
      flightNumber: flightLeg.flightnumber,
      carrier: flightLeg.carrier,
      destination: flightLeg.destination,
      jtype,
      origin: flightLeg.origin,
      passenger_fname: '',
      passenger_lname: '',
      passenger_title: '',
      paxid: '',
      paxtype: traveller.type,
      ssr_chargeableamount: '',
      ssrcode: '',
      ssrname: '',
      ssrtype: 'specialssr',
      travellerIndex: index,
    }));
  };

  const getKValue = (list) => {
    let kValue = 0;
    if (list.length > 0) {
      list.forEach((tax) => {
        if (tax.taxcode.includes('ADT_K3')) {
          kValue = tax.taxamount;
        } else if (
          tax.taxcode.indexOf('ADT') > -1 &&
          tax.taxcode.indexOf('GST') > -1
        ) {
          kValue = tax.taxamount;
        }
      });
    }
    return kValue;
  };

  const initData = async () => {
    isApiRequestProcessingRef.current = true;
    setIsLoading(true);
    Object.keys(selectedFare).forEach((sec) => {
      const secFare = selectedFare[sec];
      const adultBaseFare = secFare?.adultbasefare;
      const adultOtTax = secFare?.adulttax;
      const adultFuelCharge = secFare?.adultyq;
      let adultKValue = 0;
      const { othertaxesbreakup } = secFare;
      const list = Array.isArray(othertaxesbreakup)
        ? othertaxesbreakup
        : [othertaxesbreakup];
      adultKValue = getKValue(list);
      const adultTotalFare = adultBaseFare + adultOtTax;
      const childBaseFare = secFare?.childbasefare;
      const childTotalTax = secFare?.childtax;
      const childFuelCharge = secFare?.childyq;
      const childTotalFare = childBaseFare + childTotalTax;
      const infantBaseFare = secFare?.infantbasefare;
      const infantTotalTax = secFare?.infanttax;
      const infantFuelCharge = secFare?.infantyq;
      const infantTotalFare = infantBaseFare + infantTotalTax;
      const handlingCharges = secFare?.handlingcharges;
      const serviceTax = secFare?.servicetax;
      const markUp = secFare?.markup;
      const tds = secFare?.tds;
      const discount = secFare?.discount;
      const plbEarned = secFare?.plb;
      const totalNet = secFare?.totalnet;
      const totalBaseFare = secFare?.totalbasefare;
      const totalTax = secFare?.totaltax;
      const totalFq = secFare?.totalfq;
      const insuranceAmount = 0;
      const AdditionalMarkupToShow = 0;
      fareSummaryRef.current[sec] = {
        adultBaseFare,
        childBaseFare,
        infantBaseFare,
        adultKValue,
        adultTotalFare,
        childTotalFare,
        infantTotalFare,
        childTotalTax,
        infantTotalTax,
        adultFuelCharge,
        childFuelCharge,
        infantFuelCharge,
        handlingCharges,
        gst: serviceTax,
        tds,
        markUp,
        discount,
        totalBaseFare,
        totalTax,
        seatPrice: 0,
        mealPrice: 0,
        baggagePrice: 0,
        AdditionalMarkupToShow,
        totalFare: totalFq + insuranceAmount,
        totalNet,
        totalFq,
        plbEarned,
        adultOtTax,
        totalAmountToShow: totalNet + insuranceAmount,
      };
    });

    const numAdults = parseInt(searchRequest.numadults, 10);
    const numChildren = parseInt(searchRequest.numchildren, 10);
    const numInfants = parseInt(searchRequest.numinfants, 10);
    setEligiblePaxForTravelInsurance(numAdults + numChildren);
    let list = [];
    const adults = new Array(numAdults).fill(0).map(() => ({
      title: '',
      first_name: '',
      last_name: '',
      dob: '',
      type: 'Adult',
      tour_code: '',
      deal_code: '',
      frequent_flyer_number: '',
      visa: '',
      passport: '',
      passport_dateofexpiry: '',
      passport_dateofissue: '',
      passport_placeofissue: '',
      agentid: '',
      meal_preference: '',
      seat_preference: '',
      additional_segmentinfo: '',
      paxssrinfo: [],
      profileid: '',
      endorsement_code: '',
      beneficiaryname: '',
      additional_basehc: 0,
      additional_taxhc: 0,
      gender: '',
    }));
    const children = new Array(numChildren).fill(0).map(() => ({
      title: '',
      first_name: '',
      last_name: '',
      dob: '',
      type: 'Child',
      tour_code: '',
      deal_code: '',
      frequent_flyer_number: '',
      visa: '',
      passport: '',
      passport_dateofexpiry: '',
      passport_dateofissue: '',
      passport_placeofissue: '',
      agentid: '',
      meal_preference: '',
      seat_preference: '',
      additional_segmentinfo: '',
      paxssrinfo: [],
      profileid: '',
      endorsement_code: '',
      beneficiaryname: '',
      additional_basehc: 0,
      additional_taxhc: 0,
      gender: '',
    }));
    const infants = new Array(numInfants).fill(0).map(() => ({
      title: '',
      first_name: '',
      last_name: '',
      dob: '',
      type: 'Infant',
      tour_code: '',
      deal_code: '',
      frequent_flyer_number: '',
      visa: '',
      passport: '',
      passport_dateofexpiry: '',
      passport_dateofissue: '',
      passport_placeofissue: '',
      agentid: '',
      meal_preference: '',
      seat_preference: '',
      additional_segmentinfo: '',
      paxssrinfo: [],
      profileid: '',
      endorsement_code: '',
      beneficiaryname: '',
      additional_basehc: 0,
      additional_taxhc: 0,
      gender: '',
    }));
    list = [...adults, ...children, ...infants];
    const markupList = [];
    list.forEach((pax) => {
      const markupObj = { Type: pax.type, tax_amount: '' };
      markupList.push(markupObj);
    });
    setTempMarkupList(markupList);
    const userSelectedSsrRowsTemp = {};
    searchArrayRef.current.forEach((sec, index) => {
      selectedFlight[sec].flightlegs.forEach((flightLeg) => {
        const sectorKey = `${flightLeg.origin} - ${flightLeg.destination} - ${index}`;
        flightSectorsRef.current.push(sectorKey);
        onwardFlightSectorsRef.current.push(sectorKey);
        userSelectedSsrRowsTemp[sectorKey] = {
          baggageRows: getBaggageSsrRows(list, flightLeg, sec),
          mealRows: getMealSsrRows(list, flightLeg, sec),
          seatRows: getSeatSsrRows(list, flightLeg, sec),
          specialSsrRows: getSpecialSsrRows(list, flightLeg, sec),
          specialAssistanceRows: getSpecialAssistanceRows(list, flightLeg, sec),
        };
      });
      if (selectedFlight[sec].flightlegs.length > 0) {
        const { origin } = selectedFlight[sec].flightlegs[0];
        const { destination } =
          selectedFlight[sec].flightlegs[
            selectedFlight[sec].flightlegs.length - 1
          ];
        const sectorKey = `${origin} - ${destination} - ${index}`;
        journeySectorsRef.current.push(sectorKey);
        if (userSelectedSsrRowsTemp[sectorKey] === undefined) {
          const flightLeg = {
            origin,
            destination,
            carrier: selectedFlight[sec].flightlegs[0].carrier,
            flightnumber: selectedFlight[sec].flightlegs[0].flightnumber,
          };
          userSelectedSsrRowsTemp[sectorKey] = {
            baggageRows: getBaggageSsrRows(list, flightLeg, sec),
            mealRows: getMealSsrRows(list, flightLeg, sec),
            seatRows: getSeatSsrRows(list, flightLeg, sec),
            specialSsrRows: getSpecialSsrRows(list, flightLeg, sec),
            specialAssistanceRows: getSpecialAssistanceRows(
              list,
              flightLeg,
              sec,
            ),
          };
        }
        const legs = selectedFlight[sec].flightlegs;
        if (legs.length > 1) {
          legs.forEach((leg, legindex) => {
            if (legindex !== legs.length - 1) {
              const currentLegKey = `${leg.carrier} - ${leg.flightnumber}`;
              const nextlegKey = `${legs[legindex + 1].carrier} - ${
                legs[legindex + 1].flightnumber
              }`;
              if (currentLegKey === nextlegKey) {
                const legKey = `${leg.origin} - ${
                  legs[legindex + 1].destination
                } - ${index}`;
                if (userSelectedSsrRowsTemp[legKey] === undefined) {
                  const legOrigin = leg.origin;
                  const legDestination = legs[legindex + 1].destination;
                  const legCarrier = leg.carrier;
                  const legFlightNumber = leg.flightnumber;
                  const flightLeg = {
                    origin: legOrigin,
                    destination: legDestination,
                    carrier: legCarrier,
                    flightnumber: legFlightNumber,
                  };
                  userSelectedSsrRowsTemp[legKey] = {
                    baggageRows: getBaggageSsrRows(list, flightLeg, sec),
                    mealRows: getMealSsrRows(list, flightLeg, sec),
                    seatRows: getSeatSsrRows(list, flightLeg, sec),
                    specialSsrRows: getSpecialSsrRows(list, flightLeg, sec),
                    specialAssistanceRows: getSpecialAssistanceRows(
                      list,
                      flightLeg,
                      sec,
                    ),
                  };
                }
              }
            }
          });
        }
      }
    });

    // let isGds = false;
    // let isSearies = false;
    // selectedFlight.onward.flightlegs.forEach((leg) => {
    //   if (['AI', 'UK'].indexOf(leg.carrier.substring(0, 2)) > -1) {
    //     isGds = true;
    //   }
    //   if (leg.carriername.toLowerCase().includes('series')) {
    //     isSearies = true;
    //   }
    // });
    // if (selectedFlight.return) {
    //   selectedFlight.return.flightlegs.forEach((leg) => {
    //     if (['AI', 'UK'].indexOf(leg.carrier.substring(0, 2)) > -1) {
    //       isGds = true;
    //     }
    //     if (leg.carriername.toLowerCase().includes('series')) {
    //       isSearies = true;
    //     }
    //   });
    // }
    // if (
    //   passThroughInfo &&
    //   passThroughInfo !== null &&
    //   passThroughInfo !== undefined
    // ) {
    //   const isPassThroughAvail =
    //     passThroughInfo.onwardPassthrough || passThroughInfo.returnPassthrough;
    //   setIsPassthrough(isPassThroughAvail);
    //   if (
    //     passThroughInfo &&
    //     passThroughInfo.onwardcards &&
    //     passThroughInfo.onwardcards !== ''
    //   ) {
    //     const onwardId =
    //       passThroughInfo.onwardcards?.OnwardPassThroughCard
    //         ?.onwardPassthroughId;
    //     if (onwardId) {
    //       setOnwardPassThroughId(onwardId);
    //     }
    //   }
    //   if (
    //     passThroughInfo &&
    //     passThroughInfo.returncards &&
    //     passThroughInfo.returncards !== ''
    //   ) {
    //     const returnId =
    //       passThroughInfo.returncards?.ReturnPassThroughCard
    //         ?.returnPassthroughId;
    //     if (returnId) {
    //       setReturnPassThroughId(returnId);
    //     }
    //   }
    // }
    // setIsGdsSearch(isGds);
    // setIsSeriesFare(isSearies);
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
    setTravellers(list);
    scrollToTop();
    setIsLoading(false);
  };

  // console.log(userSelectedSsrRows);

  useEffect(() => {
    searchRequest.origin.split(':').forEach((d, index) => {
      const sec = `${d} - ${
        searchRequest.destination.split(':')[index]
      } - ${formatDate(getNewDate(getOnwardDate(index)), API_DATE_FORMAT)}`;
      searchArrayRef.current.push(sec);
    });
    if (!isApiRequestProcessingRef.current) {
      initData();
    }
  }, []);

  const handleTitleSelect = (selected, index) => {
    const list = [...travellers];
    if (selected !== null) {
      list[index].title = selected.value;
      if (selected.value === 'Mr' || selected.value === 'Mstr') {
        list[index].gender = 'M';
      } else {
        list[index].gender = 'F';
      }
    } else {
      list[index].title = '';
      list[index].gender = '';
    }
    setTravellers(list);
  };
  const handleGenderSelect = (selected, index) => {
    const list = [...travellers];
    if (selected !== null) {
      list[index].gender = selected.value;
    } else {
      list[index].gender = '';
    }
    setTravellers(list);
  };

  const handleSwitchChange = (index) => {
    const list = [...travellers];
    list[index].specialAssitance = true;
    selectedTravellerRef.current = list[index];
    selectedSpecialAssistanceIndexRef.current = index;
    setShowSpecialAssistance(true);
    setTravellers(list);
  };

  const handleTextInputChange = (event, index) => {
    const { name, value } = event.target;
    const list = [...travellers];
    list[index][name] = value;
    setTravellers(list);
  };

  const handleAddAddOn = async (addOnType) => {
    if (addOnType === ADDONS.SEAT) {
      if (!hasSeatMapRef.current) {
        setIsLoading(true);
        await getSeatLayout();
        hasSeatMapRef.current = true;
      } else if (hasSeatMapRef.current) {
        setShowSeatMap(true);
      }
    } else if (!hasSsrRef.current) {
      setIsLoading(true);
      await getSSRLayout(addOnType);
      hasSsrRef.current = true;
    } else if (hasSsrRef.current) {
      setIsLoading(false);
      if (addOnType === ADDONS.MEALS) {
        setActiveMealIndex(0);
        setShowMeals(true);
      } else if (addOnType === ADDONS.BAGGAGE) {
        setActiveBagIndex(0);
        setShowBaggage(true);
      } else if (addOnType === ADDONS.SPECIAL_SSR) {
        setActiveSsrIndex(0);
        setShowSpecialSsr(true);
      }
    }
  };

  const handleUpdateTotalNet = (userSelectedSsrRowsTemp) => {
    Object.keys(selectedFare).forEach((sec) => {
      let seatPrice = 0;
      let mealPrice = 0;
      let baggagePrice = 0;
      let specialSsrPrice = 0;
      let insuranceAmount = 0;
      let hasSeat = false;
      let hasMeal = false;
      let hasBaggage = false;
      let hasSpecialSsr = false;
      let addMarkup = 0;
      Object.keys(userSelectedSsrRowsTemp).forEach((key) => {
        userSelectedSsrRowsTemp[key].seatRows.forEach((row) => {
          if (
            row.ssr_chargeableamount !== '' &&
            row.ssr_chargeableamount !== undefined &&
            row.jtype === sec
          ) {
            seatPrice += row.ssr_chargeableamount;
            hasSeat = true;
          }
        });
        userSelectedSsrRowsTemp[key].mealRows.forEach((row) => {
          if (
            row.ssr_chargeableamount !== '' &&
            row.ssr_chargeableamount !== undefined &&
            row.jtype === sec
          ) {
            mealPrice += row.ssr_chargeableamount;
            hasMeal = true;
          }
        });
        userSelectedSsrRowsTemp[key].baggageRows.forEach((row) => {
          if (
            row.ssr_chargeableamount !== '' &&
            row.ssr_chargeableamount !== undefined &&
            row.jtype === sec
          ) {
            baggagePrice += row.ssr_chargeableamount;
            hasBaggage = true;
          }
        });
        userSelectedSsrRowsTemp[key].specialSsrRows.forEach((row) => {
          if (
            row.ssr_chargeableamount !== '' &&
            row.ssr_chargeableamount !== undefined &&
            row.jtype === sec
          ) {
            specialSsrPrice += row.ssr_chargeableamount;
            hasSpecialSsr = true;
          }
        });
      });
      if (hasTravelInsurance) {
        insuranceAmount = 200;
      }
      if (showMarkup) {
        addMarkup = additionalMarkup;
      }
      fareSummaryRef.current[sec].hasSeat = hasSeat;
      fareSummaryRef.current[sec].hasMeal = hasMeal;
      fareSummaryRef.current[sec].hasBaggage = hasBaggage;
      fareSummaryRef.current[sec].hasSpecialSsr = hasSpecialSsr;
      fareSummaryRef.current[sec].seatPrice = seatPrice;
      fareSummaryRef.current[sec].mealPrice = mealPrice;
      fareSummaryRef.current[sec].baggagePrice = baggagePrice;
      fareSummaryRef.current[sec].specialSsrPrice = specialSsrPrice;
      fareSummaryRef.current[sec].AdditionalMarkupToShow = addMarkup;
      fareSummaryRef.current[sec].totalAmountToShow =
        fareSummaryRef.current[sec].totalNet +
        seatPrice +
        mealPrice +
        baggagePrice +
        specialSsrPrice +
        insuranceAmount;
      fareSummaryRef.current[sec].totalFare =
        fareSummaryRef.current[sec].totalFq +
        seatPrice +
        mealPrice +
        baggagePrice +
        specialSsrPrice +
        insuranceAmount +
        addMarkup;
    });
  };

  const getTotalFare = () => {
    let total = 0;
    Object.keys(fareSummaryRef.current).forEach((sec) => {
      if (
        fareSummaryRef.current[sec] &&
        fareSummaryRef.current[sec].totalFare
      ) {
        total += fareSummaryRef.current[sec].totalFare;
      }
    });
    return total;
  };

  const handleSeatSelection = (seat, sector) => {
    if (seat.seatstatus === 'Open') {
      const childRestricted =
        seat &&
        seat.additionalinfo.toLowerCase().indexOf('childrestricted') > 1;
      if (
        travellers[activeSeatIndex].type.toLowerCase() === 'child' &&
        childRestricted
      ) {
        setAlert({
          title: formattedMessage('seat_selection'),
          description: formattedMessage('reserved_for_child_alert'),
          variant: 'error',
        });
      } else {
        const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
        if (
          userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode !==
            seat.seatdesignator &&
          userSelectedSsrRowsTemp[sector].seatRows.filter(
            (x) => x.ssrcode === seat.seatdesignator,
          ).length > 0
        ) {
          setAlert({
            title: formattedMessage('seat_selection'),
            description: formattedMessage('reserved_for_other_pax_alert'),
            variant: 'error',
          });
        } else if (
          userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode ===
          seat.seatdesignator
        ) {
          userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode =
            '';
          userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrname =
            '';
          userSelectedSsrRowsTemp[sector].seatRows[
            activeSeatIndex
          ].ssr_chargeableamount = '';
        } else {
          userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrcode =
            seat.seatdesignator;
          userSelectedSsrRowsTemp[sector].seatRows[activeSeatIndex].ssrname =
            seat.seatgroup;
          userSelectedSsrRowsTemp[sector].seatRows[
            activeSeatIndex
          ].ssr_chargeableamount = seat.seatprice;
        }
        handleUpdateTotalNet(userSelectedSsrRowsTemp);
        setUserSelectedSsrRows(userSelectedSsrRowsTemp);
        const eligiblePaxLength =
          parseInt(searchRequest.numadults, 10) +
          parseInt(searchRequest.numchildren, 10);
        const sectors = Object.keys(flightLegsWithSeatsRef.current);
        const newFilterdSeatSector = sectors.filter((sr) =>
          userSelectedSsrRowsTemp[sr].seatRows.some((s) => s.ssrcode === ''),
        );

        const hasSelectedSeatForThisSector = (passengerIndex, givenSector) => {
          return (
            userSelectedSsrRowsTemp[givenSector].seatRows[passengerIndex]
              .ssrcode !== ''
          );
        };

        const countPassengersWithSeatForThisSector = (givenSector) => {
          let count = 0;
          travellers.forEach((traveller, index) => {
            if (traveller.type.toLowerCase() !== 'infant') {
              if (hasSelectedSeatForThisSector(index, givenSector)) {
                count++;
              }
            }
          });
          return count;
        };

        const numPaxSelectedseatsForSector =
          countPassengersWithSeatForThisSector(sector);

        let numSeatSelectedPax = 0;
        sectors.forEach((d) => {
          travellers.forEach((traveller, index) => {
            if (traveller.type.toLowerCase() !== 'infant') {
              if (hasSelectedSeatForThisSector(index, d)) {
                numSeatSelectedPax++;
              }
            }
          });
        });

        let numSelectedSeats = 0;
        sectors.forEach((d) => {
          userSelectedSsrRowsTemp[d].seatRows.forEach((seatRow) => {
            if (seatRow.ssrcode !== '') {
              numSelectedSeats += 1;
            }
          });
        });

        const maxSeatsForSelection = sectors.length * eligiblePaxLength;
        if (!isSeatEditMode) {
          if (
            activeSeatIndex < travellers.length - 1 &&
            travellers[activeSeatIndex + 1].type.toLowerCase() !== 'infant'
          ) {
            setActiveSeatIndex(activeSeatIndex + 1);
          }
          if (numPaxSelectedseatsForSector === eligiblePaxLength) {
            if (newFilterdSeatSector.length > 0) {
              setSeatSelectionSector(newFilterdSeatSector[0]);
              setActiveSeatIndex(0);
            }
          }
          if (maxSeatsForSelection === numSelectedSeats) {
            setShowSeatMap(false);
            setIsSeatEditMode(true);
          }
        }
      }
    }
  };

  const handleAddMeal = (meal, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    const firstMealRow = userSelectedSsrRowsTemp[sector].mealRows.find(
      (row) => row.travellerIndex === activeMealIndex,
    );
    userSelectedSsrRowsTemp[sector].mealRows[activeMealIndex] = {
      ...firstMealRow,
      ssrcode: meal.ssrcode,
      ssrname: meal.ssrname,
      ssr_chargeableamount: meal.chargeableamount,
    };
    handleUpdateTotalNet(userSelectedSsrRowsTemp);
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);

    const eligiblePaxLength =
      parseInt(searchRequest.numadults, 10) +
      parseInt(searchRequest.numchildren, 10);
    const sectors = Object.keys(flightLegsWithMealRef.current);
    const newFilterdmealSector = sectors.filter((ms) => ms !== sector);

    const hasSelectedMealForThisSector = (passengerIndex, givenSector) => {
      return userSelectedSsrRowsTemp[givenSector].mealRows.some(
        (mr) => mr.ssrcode !== '' && mr.travellerIndex === passengerIndex,
      );
    };

    const countPassengersWithMealForThisSector = (givenSector) => {
      let count = 0;
      travellers.forEach((traveller, index) => {
        if (traveller.type.toLowerCase() !== 'infant') {
          if (hasSelectedMealForThisSector(index, givenSector)) {
            count++;
          }
        }
      });
      return count;
    };
    const numPaxSelectedmealsForSector =
      countPassengersWithMealForThisSector(sector);

    let numMealSelectedPax = 0;
    sectors.forEach((d) => {
      travellers.forEach((traveller, index) => {
        if (traveller.type.toLowerCase() !== 'infant') {
          if (hasSelectedMealForThisSector(index, d)) {
            numMealSelectedPax++;
          }
        }
      });
    });
    const maxMealForSelection = sectors.length * eligiblePaxLength;
    if (!isMealEditMode) {
      if (
        activeMealIndex < travellers.length - 1 &&
        travellers[activeMealIndex + 1].type.toLowerCase() !== 'infant'
      ) {
        setActiveMealIndex(activeMealIndex + 1);
      }
      if (numPaxSelectedmealsForSector === eligiblePaxLength) {
        if (newFilterdmealSector.length > 0) {
          const newRows = newFilterdmealSector.filter(
            (sec) =>
              hasSelectedMealForThisSector(activeMealIndex, sec) === false,
          );
          if (newRows.length > 0) {
            setMealSelectionSector(newRows[0]);
          } else {
            setMealSelectionSector(newFilterdmealSector[0]);
          }
          setActiveMealIndex(0);
        }
      }
      if (maxMealForSelection === numMealSelectedPax) {
        setIsMealEditMode(true);
        setActiveMealIndex(0);
      }
    }
  };

  const handleAddBaggage = (baggage, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    const rows = userSelectedSsrRowsTemp[sector].baggageRows.filter(
      (row) =>
        row.travellerIndex === activeBagIndex &&
        row.ssrcode === baggage.ssrcode,
    );
    if (rows.length > 0) {
      setAlert({
        variant: 'error',
        title: 'Baggage Selection',
        description: 'You cannot select the same baggage type',
      });
    } else {
      const allRows = userSelectedSsrRowsTemp[sector].baggageRows.filter(
        (row) => row.travellerIndex === activeBagIndex,
      );
      let sumKg = 0;
      allRows.push(baggage);
      allRows.forEach((row) => {
        if (row.ssrcode.indexOf('IN') > -1) {
          const kg = Number(row.ssrcode.replace('IN', ''));
          sumKg += kg;
        }
        if (row.ssrcode.indexOf('XC') > -1) {
          const kg = Number(row.ssrcode.replace('XC', ''));
          sumKg += kg;
        }
      });
      if (sumKg > 60) {
        setAlert({
          variant: 'error',
          title: 'Baggage Selection',
          description: 'You cannot select morethan 60kg baggage',
        });
      } else {
        const firstBaggageRow = userSelectedSsrRowsTemp[
          sector
        ].baggageRows.find((row) => row.travellerIndex === activeBagIndex);
        userSelectedSsrRowsTemp[sector].baggageRows[activeBagIndex] = {
          ...firstBaggageRow,
          ssrcode: baggage.ssrcode,
          ssrname: baggage.ssrname,
          ssr_chargeableamount: baggage.chargeableamount,
        };
        handleUpdateTotalNet(userSelectedSsrRowsTemp);
        setUserSelectedSsrRows(userSelectedSsrRowsTemp);

        const eligiblePaxLength =
          parseInt(searchRequest.numadults, 10) +
          parseInt(searchRequest.numchildren, 10);
        const sectors = Object.keys(flightLegsWithBaggageRef.current);
        const newFilterdBagSector = sectors.filter((ms) => ms !== sector);

        const hasSelectedBagForThisSector = (passengerIndex, givenSector) => {
          return userSelectedSsrRowsTemp[givenSector].baggageRows.some(
            (mr) => mr.ssrcode !== '' && mr.travellerIndex === passengerIndex,
          );
        };

        const countPassengersWithBagForThisSector = (givenSector) => {
          let count = 0;
          travellers.forEach((traveller, index) => {
            if (traveller.type.toLowerCase() !== 'infant') {
              if (hasSelectedBagForThisSector(index, givenSector)) {
                count++;
              }
            }
          });
          return count;
        };

        const numPaxSelectedbagsForSector =
          countPassengersWithBagForThisSector(sector);

        let numBagselectedPax = 0;
        sectors.forEach((d) => {
          travellers.forEach((traveller, index) => {
            if (traveller.type.toLowerCase() !== 'infant') {
              if (hasSelectedBagForThisSector(index, d)) {
                numBagselectedPax++;
              }
            }
          });
        });
        const maxBagForSelection = sectors.length * eligiblePaxLength;

        if (!isBagEditMode) {
          if (
            activeBagIndex < travellers.length - 1 &&
            travellers[activeBagIndex + 1].type.toLowerCase() !== 'infant'
          ) {
            setActiveBagIndex(activeBagIndex + 1);
          }
          if (numPaxSelectedbagsForSector === eligiblePaxLength) {
            if (newFilterdBagSector.length > 0) {
              setBaggageSelectionSector(newFilterdBagSector[0]);
              setActiveBagIndex(0);
            }
          }
          if (maxBagForSelection === numBagselectedPax) {
            setIsBagEditMode(true);
            setActiveBagIndex(0);
          }
        }
      }
    }
  };

  const handleAddSpecialSsr = (specialSsr, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };

    const rows = userSelectedSsrRowsTemp[sector].specialSsrRows.filter(
      (row) =>
        row.travellerIndex === activeSsrIndex &&
        row.ssrcode === specialSsr.ssrcode,
    );
    if (rows.length > 0) {
      setAlert({
        variant: 'error',
        title: 'Special SSR Selection',
        description: 'You cannot select the same SSR type',
      });
    } else {
      const firstSsrRow = userSelectedSsrRowsTemp[sector].specialSsrRows.find(
        (row) => row.travellerIndex === activeSsrIndex,
      );
      userSelectedSsrRowsTemp[sector].specialSsrRows[activeSsrIndex] = {
        ...firstSsrRow,
        ssrcode: specialSsr.ssrcode,
        ssrname: specialSsr.ssrname,
        ssr_chargeableamount: specialSsr.chargeableamount,
      };
      handleUpdateTotalNet(userSelectedSsrRowsTemp);
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);

      const eligiblePaxLength =
        parseInt(searchRequest.numadults, 10) +
        parseInt(searchRequest.numchildren, 10);
      const sectors = Object.keys(flightLegsWithSpecialSsr.current);
      const newFilterdSpecialSsrSector = sectors.filter((ms) => ms !== sector);

      const hasSelectedSpecialSsrForThisSector = (
        passengerIndex,
        givenSector,
      ) => {
        return userSelectedSsrRowsTemp[givenSector].specialSsrRows.some(
          (mr) => mr.ssrcode !== '' && mr.travellerIndex === passengerIndex,
        );
      };

      const countPassengersWithSpecialSsrForThisSector = (givenSector) => {
        let count = 0;
        travellers.forEach((traveller, index) => {
          if (traveller.type.toLowerCase() !== 'infant') {
            if (hasSelectedSpecialSsrForThisSector(index, givenSector)) {
              count++;
            }
          }
        });
        return count;
      };
      const numPaxSelectedspecialSsrsForSector =
        countPassengersWithSpecialSsrForThisSector(sector);

      let numSpecialSsrSelectedPax = 0;
      sectors.forEach((d) => {
        travellers.forEach((traveller, index) => {
          if (traveller.type.toLowerCase() !== 'infant') {
            if (hasSelectedSpecialSsrForThisSector(index, d)) {
              numSpecialSsrSelectedPax++;
            }
          }
        });
      });
      const maxSpecialSsrForSelection = sectors.length * eligiblePaxLength;

      if (!isSpecialSSREditMode) {
        if (
          activeSsrIndex < travellers.length - 1 &&
          travellers[activeSsrIndex + 1].type.toLowerCase() !== 'infant'
        ) {
          setActiveSsrIndex(activeSsrIndex + 1);
        }
        if (numPaxSelectedspecialSsrsForSector === eligiblePaxLength) {
          if (newFilterdSpecialSsrSector.length > 0) {
            setSpecialSsrSelectionSector(newFilterdSpecialSsrSector[0]);
            setActiveSsrIndex(0);
          }
        }
        if (maxSpecialSsrForSelection === numSpecialSsrSelectedPax) {
          setIsSpecialSSREditMode(true);
          setActiveSsrIndex(0);
        }
      }
    }
  };

  const getAddStatus = () => {
    if (Object.entries(userSelectedSsrRows).length > 0) {
      const sectorValues = Object.values(userSelectedSsrRows);
      const tempSSRrows = Array.isArray(sectorValues)
        ? sectorValues
        : [sectorValues];
      let isSeat = false;
      let isBag = false;
      let isMeal = false;
      let isSpecialSsr = false;
      if (tempSSRrows.length > 0) {
        tempSSRrows.forEach((sector) => {
          sector.seatRows.forEach((row) => {
            if (row.ssrcode !== '') {
              isSeat = true;
            }
          });
          sector.baggageRows.forEach((row) => {
            if (row.ssrcode !== '') {
              isBag = true;
            }
          });
          sector.mealRows.forEach((row) => {
            if (row.ssrcode !== '') {
              isMeal = true;
            }
          });
          sector.specialSsrRows.forEach((row) => {
            if (row.ssrcode !== '') {
              isSpecialSsr = true;
            }
          });
        });
      }
      setIsBaggageSelected(isBag);
      setIsMealSelected(isMeal);
      setIsSeatSelected(isSeat);
      setIsSpecialSsrSelected(isSpecialSsr);
    }
  };

  useEffect(() => {
    getAddStatus();
  }, [userSelectedSsrRows]);

  const handleRemoveSeat = (seat, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    const filterdIndex = userSelectedSsrRowsTemp[sector].seatRows.findIndex(
      (row) => seat.ssrcode === row.ssrcode,
    );
    userSelectedSsrRowsTemp[sector].seatRows[filterdIndex].ssrname = '';
    userSelectedSsrRowsTemp[sector].seatRows[filterdIndex].ssrcode = '';
    userSelectedSsrRowsTemp[sector].seatRows[
      filterdIndex
    ].ssr_chargeableamount = '';
    handleUpdateTotalNet(userSelectedSsrRowsTemp);
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
  };
  const handleRemoveMeal = (meal, index, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    const existingMeal = {
      ...userSelectedSsrRowsTemp[sector].mealRows[index],
    };
    userSelectedSsrRowsTemp[sector].mealRows[index] = {
      ...existingMeal,
      ssrcode: '',
      ssrname: '',
      ssr_chargeableamount: '',
    };
    handleUpdateTotalNet(userSelectedSsrRowsTemp);
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
  };

  const handelRemoveBaggage = (baggage, index, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    const existingBag = {
      ...userSelectedSsrRowsTemp[sector].baggageRows[index],
    };
    userSelectedSsrRowsTemp[sector].baggageRows[index] = {
      ...existingBag,
      ssrcode: '',
      ssrname: '',
      ssr_chargeableamount: '',
    };
    handleUpdateTotalNet(userSelectedSsrRowsTemp);
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
  };

  const handelRemoveSpecialSsr = (specialSsr, index, sector) => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    const existingSpecialSSR = {
      ...userSelectedSsrRowsTemp[sector].specialSsrRows[index],
    };
    userSelectedSsrRowsTemp[sector].specialSsrRows[index] = {
      ...existingSpecialSSR,
      ssrcode: '',
      ssrname: '',
      ssr_chargeableamount: '',
    };
    handleUpdateTotalNet(userSelectedSsrRowsTemp);
    // setIsSpecialSsrSelected(true);
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
  };

  const getSelectedBaggage = (userBaggageRows, index) => {
    const filterdBaggage = userBaggageRows.filter(
      (row) => row.travellerIndex === index && row.ssrname !== '',
    );

    return filterdBaggage.length === 0 ? (
      formattedMessage('select_baggage')
    ) : (
      <ul className="selected-meals">
        {filterdBaggage.map((baggage, fmi) => (
          <li key={fmi}>
            <span>
              {baggage.ssrname} • {formatCurrency(baggage.ssr_chargeableamount)}
            </span>
            <AppIconButton
              onClick={() =>
                handelRemoveBaggage(
                  baggage,
                  index,
                  `${baggage.origin} - ${baggage.destination}`,
                )
              }
              variant="secondary"
            >
              <MdClose />
            </AppIconButton>
          </li>
        ))}
      </ul>
    );
  };

  const handleSelectCustomer = (customer) => {
    const list = [...travellers];
    if (selectedCustomerRef.current === 0) {
      setLeademail(customer.Email);
      setLeadmobile(customer.Phone);
    }
    list[selectedCustomerRef.current].first_name = customer.FirstName;
    list[selectedCustomerRef.current].last_name = customer.LastName;
    list[selectedCustomerRef.current].gender =
      customer.Gender === 'female' ? 'F' : 'M';
    list[selectedCustomerRef.current].title = customer.Title;

    setTravellers(list);
    setShowSelectPaxModal(false);
    setCustomers([]);
    setProfileName('');
  };

  const handleSearchCustomer = async () => {
    setIsLoading(true);
    if (profileName !== '') {
      const response = await chooseCustomerApi(profileName, getUserAgentId());
      if (
        response.Root.Status === 'OK' &&
        response.Root.Result.ProfileMasters !== ''
      ) {
        const { ProfileMasters } = response.Root.Result;
        const { ProfileMaster } = ProfileMasters;
        const list = Array.isArray(ProfileMaster)
          ? ProfileMaster
          : [ProfileMaster];
        const firstCustomer = list[0];
        setCustomers(list);
      } else {
        setCustomers([]);
        setAlert({
          title: 'Profile Search',
          description: 'No Profiles Found',
          variant: 'error',
        });
      }
    } else {
      setAlert({
        title: 'Profile Search',
        description: 'Please enter name',
        variant: 'error',
      });
    }

    setIsLoading(false);
  };

  const handleConfirmationDialogClose = () => {
    setShowConfirmationDialog(false);
  };

  const handleConfirmHoldDialogClose = () => {
    setShowConfirmHoldDialog(false);
  };
  const isDobMandatoryForPax = (type) => {
    if (rePriceResponse.domint === 'international') {
      return true;
    }
    if (hasTravelInsurance) {
      return true;
    }
    if (type !== 'Adult') {
      return true;
    }
    return false;
  };

  const getOnwardDate = (index) => {
    const newDatesArray = [];
    const datesArray = searchRequest.onwarddate.split(':');
    datesArray.forEach((date) => {
      const newdate = `${date.substring(0, 4)}-${date.substring(
        4,
        6,
      )}-${date.substring(6, 8)}`;
      newDatesArray.push(newdate);
    });
    return newDatesArray[index];
  };

  const getSearchRequestForSector = (sec) => {
    const req = { ...searchRequest };
    const originArr = searchRequest.origin.split(':');
    const destinationArr = searchRequest.destination.split(':');
    const originLocationArr = searchRequest.originlocations.split(':');
    const destinationLocationArr =
      searchRequest.destinationlocations.split(':');
    const newDatesArray = [];
    const datesArray = searchRequest.onwarddate.split(':');
    datesArray.forEach((date) => {
      const newdate = `${date.substring(0, 4)}-${date.substring(
        4,
        6,
      )}-${date.substring(6, 8)}`;
      newDatesArray.push(newdate);
    });
    const selectedIndex = originArr.indexOf(sec.split(' - ')[0]);
    req.origin = originArr[selectedIndex];
    req.destination = destinationArr[selectedIndex];
    req.onwarddate = newDatesArray[selectedIndex];
    req.originLocation = originLocationArr[selectedIndex];
    req.destinationLocation = destinationLocationArr[selectedIndex];
    req.journeytype = 'OneWay';
    return req;
  };

  const getDOBMinDate = (type) => {
    if (type.toLowerCase() === 'infant') {
      const jdate = getNewDate(getOnwardDate(0));
      const minDate = subYears(jdate, 2);
      return minDate;
    }
    if (type.toLowerCase() === 'child') {
      const jdate = getNewDate(getOnwardDate(0));
      const minDate = subYears(jdate, 12);
      return minDate;
    }
    return '';
  };

  const getDOBMaxDate = (type) => {
    if (type.toLowerCase() === 'infant') {
      return getNewDate(TODAY_DATE);
    }
    if (type.toLowerCase() === 'child') {
      const jdate = getNewDate(getOnwardDate(0));
      const minDate = subYears(jdate, 2);
      return minDate;
    }
    if (type.toLowerCase() === 'adult' || type === '') {
      const jdate = getNewDate(getOnwardDate(0));
      const minDate = subYears(jdate, 12);
      return minDate;
    }
  };

  const handleBook = async () => {
    const fbIdResponse = [];
    searchArrayRef.current.forEach(async (sec) => {
      try {
        setIsLoading(true);
        setShowConfirmationDialog(false);
        setIsBookingClicked(true);
        const travellersList = [...travellers];
        let isError = false;
        for (let i = 0; i < travellersList.length; i++) {
          if (
            travellersList[i].first_name === undefined ||
            travellersList[i].first_name === '' ||
            travellersList[i].first_name.trim() === '' ||
            travellersList[i].last_name === undefined ||
            travellersList[i].last_name === '' ||
            travellersList[i].last_name.trim() === '' ||
            travellersList[i].title === ''
          ) {
            isError = true;
            setIsLoading(false);
          }
          if (
            isDobMandatoryForPax(travellersList[i].type) &&
            travellersList[i].dob === ''
          ) {
            isError = true;
            setIsLoading(false);
          }
        }
        if (
          leademail === '' ||
          leademail === undefined ||
          leadmobile === '' ||
          leadmobile === undefined
        ) {
          isError = true;
          setIsLoading(false);
        }
        travellersList.forEach((trav) => {
          delete trav.gender;
        });
        if (isError) {
          setValidationError(true);
          scrollToTop();
          return false;
        }

        let hasSpeicalChars = false;
        for (let i = 0; i < travellersList.length; i++) {
          if (
            NAME_REGEX.test(travellersList[i].first_name) === false ||
            NAME_REGEX.test(travellersList[i].last_name) === false
          ) {
            setAlert({
              variant: 'error',
              title: formattedMessage('validation_error'),
              description: `${formattedMessage('valid_traveller_name_alert')} ${
                i + 1
              }`,
            });
            hasSpeicalChars = true;
            break;
          }
        }
        if (hasSpeicalChars) {
          scrollToTop();
          setIsLoading(false);
          return false;
        }
        const sectors = Object.keys(userSelectedSsrRows);
        const selectedSsrRows = [];
        sectors.forEach((sector) => {
          userSelectedSsrRows[sector].baggageRows.forEach((row) => {
            if (row.ssr_chargeableamount !== '' && row.jtype === sec) {
              delete row.travellerIndex;
              row.jtype = 'onward';
              selectedSsrRows.push(row);
            }
          });
          userSelectedSsrRows[sector].mealRows.forEach((row) => {
            if (row.ssr_chargeableamount !== '' && row.jtype === sec) {
              delete row.travellerIndex;
              row.jtype = 'onward';
              selectedSsrRows.push(row);
            }
          });
          userSelectedSsrRows[sector].seatRows.forEach((row) => {
            if (row.ssr_chargeableamount !== '' && row.jtype === sec) {
              delete row.travellerIndex;
              row.jtype = 'onward';
              selectedSsrRows.push(row);
            }
          });
          userSelectedSsrRows[sector].specialSsrRows.forEach((row) => {
            if (
              row.ssr_chargeableamount !== '' &&
              row.ssr_chargeableamount !== undefined &&
              row.jtype === sec
            ) {
              row.jtype = 'onward';
              delete row.travellerIndex;
              selectedSsrRows.push(row);
            }
          });
          userSelectedSsrRows[sector].specialAssistanceRows.forEach((row) => {
            if (
              row.ssr_chargeableamount !== '' &&
              row.ssr_chargeableamount !== undefined &&
              row.jtype === sec
            ) {
              row.jtype = 'onward';
              delete row.travellerIndex;
              selectedSsrRows.push(row);
            }
          });
        });
        const paxList = [...travellers];
        paxList.forEach((trav) => {
          delete trav.specialAssitance;
          delete trav.gender;
        });
        const bookingRequest = {
          bookingrequest: {
            taxInfoStr: rePriceResponse[sec].bookingkey,
            leademail,
            leadmobile,
            leadcountry: 'IN',
            leadcity: 'Bangalore',
            leadstate: 'KA',
            paymentmode: paymentmode,
            domint: rePriceResponse[sec].domint,
            promocode: searchRequest.promocode,
            numadults: searchRequest.numadults,
            numchildren: searchRequest.numchildren,
            numinfants: searchRequest.numinfants,
            passengerList: paxList,
            ssrList: {
              SSRRow: selectedSsrRows,
            },
            gstdetails: {
              gstaddress: '',
              gstcompany: gst.gstcompany,
              gstnumber: gst.gstnumber,
              gstemail: gst.gstemail,
              gstphone: '',
            },
            wsmode: 'test',
            ispassthrough: isPassThrough ? true : false,
            onwardpassthroughid: onwardPassThroughId,
            returnpassthroughid: returnPassThroughId,
            travelinsurance_included: hasTravelInsurance ? 'true' : 'false',
            travelinsurance_amount: hasTravelInsurance
              ? eligiblePaxForTravelInsurance * 61
              : 0,
          },
        };
        if (
          bookingRequest.bookingrequest.gstdetails.gstcompany === '' ||
          bookingRequest.bookingrequest.gstdetails.gstnumber === '' ||
          bookingRequest.bookingrequest.gstdetails.gstemail === ''
        ) {
          bookingRequest.bookingrequest.gstdetails = {
            gstaddress: '',
            gstcompany: '',
            gstnumber: '',
            gstemail: '',
            gstphone: '',
          };
        }
        const userProfile = getObjectFromLS(APP_USER_PROFILE);
        const opid = paymentmode === 'cashcard' ? 'TX004' : 'TX005';
        const actioncode =
          rePriceResponse[sec].domint === 'international' ? 'INTL' : 'DOM';
        const response = await bookFlightApi(
          bookingRequest,
          userProfile.agentId,
          actioncode,
          opid,
        );
        if (response && response.ApiStatus.Status === 'OK') {
          if (paymentmode === 'cashcard') {
            fbIdResponse.push({
              sector: sec,
              fbid: response.ApiStatus.Result,
              status: 'success',
            });
          } else {
            const { Result } = response.ApiStatus;
            if (Result !== '') {
              const { PgUrl, Txid } = Result;
              window.location.href = `${PgUrl}?txid=${Txid}`;
            }
          }
        } else {
          fbIdResponse.push({
            sector: sec,
            fbid: response?.ApiStatus?.Result,
            status: 'failure',
          });
          setAlert({
            variant: 'error',
            title: formattedMessage('flight_booking_failed'),
            description: response.ApiStatus.Message,
          });
        }
        if (fbIdResponse.length === searchArrayRef.current.length) {
          setFlightBookingResponse(fbIdResponse);
          setIsLoading(false);
          setShowPostBookingPopup(true);
        }
      } catch (error) {
        // setIsLoading(false);
      }
    });
  };
  const handleHold = async () => {
    try {
      setIsLoading(true);
      setShowConfirmationDialog(false);
      setIsBookingClicked(true);
      const travellersList = [...travellers];
      let isError = false;
      for (let i = 0; i < travellersList.length; i++) {
        if (
          travellersList[i].first_name === undefined ||
          travellersList[i].first_name === '' ||
          travellersList[i].first_name.trim() === '' ||
          travellersList[i].last_name === undefined ||
          travellersList[i].last_name === '' ||
          travellersList[i].last_name.trim() === '' ||
          travellersList[i].title === ''
        ) {
          isError = true;
          setIsLoading(false);
        }
        if (
          isDobMandatoryForPax(travellersList[i].type) &&
          travellersList[i].dob === ''
        ) {
          isError = true;
          setIsLoading(false);
        }
      }
      if (
        leademail === '' ||
        leademail === undefined ||
        leadmobile === '' ||
        leadmobile === undefined
      ) {
        isError = true;
        setIsLoading(false);
      }
      travellersList.forEach((trav) => {
        delete trav.gender;
      });
      if (isError) {
        setValidationError(true);
        scrollToTop();
        return false;
      }

      let hasSpeicalChars = false;
      for (let i = 0; i < travellersList.length; i++) {
        if (
          NAME_REGEX.test(travellersList[i].first_name) === false ||
          NAME_REGEX.test(travellersList[i].last_name) === false
        ) {
          setAlert({
            variant: 'error',
            title: formattedMessage('validation_error'),
            description: `${formattedMessage('valid_traveller_name_alert')} ${
              i + 1
            }`,
          });
          hasSpeicalChars = true;
          break;
        }
      }
      if (hasSpeicalChars) {
        scrollToTop();
        setIsLoading(false);
        return false;
      }
      const sectors = Object.keys(userSelectedSsrRows);
      const selectedSsrRows = [];
      sectors.forEach((sector) => {
        userSelectedSsrRows[sector].baggageRows.forEach((row) => {
          if (row.ssr_chargeableamount !== '') {
            delete row.travellerIndex;
            selectedSsrRows.push(row);
          }
        });
        userSelectedSsrRows[sector].mealRows.forEach((row) => {
          if (row.ssr_chargeableamount !== '') {
            delete row.travellerIndex;
            selectedSsrRows.push(row);
          }
        });
        userSelectedSsrRows[sector].seatRows.forEach((row) => {
          if (row.ssr_chargeableamount !== '') {
            delete row.travellerIndex;
            selectedSsrRows.push(row);
          }
        });
        userSelectedSsrRows[sector].specialSsrRows.forEach((row) => {
          if (
            row.ssr_chargeableamount !== '' &&
            row.ssr_chargeableamount !== undefined
          ) {
            delete row.travellerIndex;
            selectedSsrRows.push(row);
          }
        });
        userSelectedSsrRows[sector].specialAssistanceRows.forEach((row) => {
          if (
            row.ssr_chargeableamount !== '' &&
            row.ssr_chargeableamount !== undefined
          ) {
            delete row.travellerIndex;
            selectedSsrRows.push(row);
          }
        });
      });
      const paxList = [...travellers];
      paxList.forEach((trav) => {
        delete trav.specialAssitance;
        delete trav.gender;
      });
      const bookingRequest = {
        bookingrequest: {
          taxInfoStr: rePriceResponse.bookingkey,
          leademail,
          leadmobile,
          leadcountry: 'IN',
          leadcity: 'Bangalore',
          leadstate: 'KA',
          paymentmode: paymentmode,
          domint: rePriceResponse.domint,
          promocode: searchRequest.promocode,
          numadults: searchRequest.numadults,
          numchildren: searchRequest.numchildren,
          numinfants: searchRequest.numinfants,
          passengerList: paxList,
          ssrList: {
            SSRRow: selectedSsrRows,
          },
          gstdetails: {
            gstaddress: '',
            gstcompany: gst.gstcompany,
            gstnumber: gst.gstnumber,
            gstemail: gst.gstemail,
            gstphone: '',
          },
          wsmode: 'test',
          ispassthrough: isPassThrough ? true : false,
          onwardpassthroughid: onwardPassThroughId,
          returnpassthroughid: returnPassThroughId,
          travelinsurance_included: hasTravelInsurance ? 'true' : 'false',
          travelinsurance_amount: hasTravelInsurance
            ? eligiblePaxForTravelInsurance * 200
            : 0,
        },
      };
      if (
        bookingRequest.bookingrequest.gstdetails.gstcompany === '' ||
        bookingRequest.bookingrequest.gstdetails.gstnumber === '' ||
        bookingRequest.bookingrequest.gstdetails.gstemail === ''
      ) {
        bookingRequest.bookingrequest.gstdetails = {
          gstaddress: '',
          gstcompany: '',
          gstnumber: '',
          gstemail: '',
          gstphone: '',
        };
      }
      const userProfile = getObjectFromLS(APP_USER_PROFILE);
      const actioncode =
        rePriceResponse.domint === 'international' ? 'INTL' : 'DOM';
      const response = await HoldFlightApi(
        bookingRequest,
        userProfile.agentId,
        actioncode,
      );
      if (response && response.ApiStatus.Status === 'OK') {
        setAlert({
          variant: 'success',
          title: 'Flight Hold Success',
          description: ` your transaction Id is ${response.ApiStatus.Result}, navigating to ticket page`,
        });
        setTimeout(() => {
          navigate(`/flight/ticket/${response.ApiStatus.Result}`);
        }, 2000);
      } else {
        setAlert({
          variant: 'error',
          title: 'Flight Hold Failed',
          description: response.ApiStatus.Message,
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleGstChange = (event) => {
    const { name, value } = event.target;
    setGst((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSAChange = (event, sa, sector) => {
    // updateTravellers(sa);
    // const { checked } = event.target;
    // selectedTravellerRef.current.ssrSelected = checked;
    // selectedTravellerRef.current.selectedSsrCode = sa.ssrcode;
    const wcssr = { ...wheelChairSsr };
    if (wcssr[sector] === undefined) {
      wcssr[sector] = {};
    }
    wcssr[sector][selectedSpecialAssistanceIndexRef.current] = {
      sector,
      ssrcode: sa.ssrcode,
      ssrname: sa.ssrname,
      ssr_chargeableamount: sa.chargeableamount,
      selected: true,
      first_name: selectedTravellerRef.current.first_name,
      last_name: selectedTravellerRef.current.last_name,
      title: selectedTravellerRef.current.title,
    };
    setWheelChairSsr(wcssr);
    handleUpdateTotalNet(userSelectedSsrRows);
  };

  const handleAddWheelChariSsr = () => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    const wcssr = { ...wheelChairSsr };
    Object.keys(wcssr).forEach((sector) => {
      userSelectedSsrRowsTemp[sector].specialAssistanceRows.forEach(
        (row, index) => {
          if (
            wheelChairSsr &&
            wheelChairSsr[sector] &&
            wheelChairSsr[sector][index]
          ) {
            userSelectedSsrRowsTemp[sector].specialAssistanceRows[
              index
            ].ssrcode = wheelChairSsr[sector][index].ssrcode;
            userSelectedSsrRowsTemp[sector].specialAssistanceRows[
              index
            ].ssrname = wheelChairSsr[sector][index].ssrname;
            userSelectedSsrRowsTemp[sector].specialAssistanceRows[
              index
            ].ssr_chargeableamount = 0;
          }
        },
      );
    });
    setUserSelectedSsrRows(userSelectedSsrRowsTemp);
    // const list = [...travellers];
    // list[selectedTravellerRef.current.paxIndex].specialAssitance = true;
    // selectedTravellerRef.current =
    //   list[selectedTravellerRef.current.paxIndex];
    // setTravellers(list);
    setShowSpecialAssistance(false);
  };

  const handleClearSsr = () => {
    const userSelectedSsrRowsTemp = { ...userSelectedSsrRows };
    const wcssr = { ...wheelChairSsr };
    const activeSectorWcssr =
      wcssr[specialAssistanceSelectionSector][
        selectedSpecialAssistanceIndexRef.current
      ];
    if (activeSectorWcssr !== undefined) {
      userSelectedSsrRowsTemp[
        specialAssistanceSelectionSector
      ].specialAssistanceRows[
        selectedSpecialAssistanceIndexRef.current
      ].ssrcode = '';
      userSelectedSsrRowsTemp[
        specialAssistanceSelectionSector
      ].specialAssistanceRows[
        selectedSpecialAssistanceIndexRef.current
      ].ssrname = '';
      userSelectedSsrRowsTemp[
        specialAssistanceSelectionSector
      ].specialAssistanceRows[
        selectedSpecialAssistanceIndexRef.current
      ].ssr_chargeableamount = '';

      wcssr[specialAssistanceSelectionSector][
        selectedSpecialAssistanceIndexRef.current
      ] = {
        specialAssistanceSelectionSector,
        ssrcode: '',
        ssrname: '',
        ssr_chargeableamount: '',
        selected: false,
        first_name: selectedTravellerRef.current.first_name,
        last_name: selectedTravellerRef.current.last_name,
        title: selectedTravellerRef.current.title,
      };

      setWheelChairSsr(wcssr);
      setUserSelectedSsrRows(userSelectedSsrRowsTemp);
      // const list = [...travellers];
      // list[selectedTravellerRef.current.paxIndex].specialAssitance = false;
      // selectedTravellerRef.current =
      //   list[selectedTravellerRef.current.paxIndex];
      // selectedTravellerRef.current.ssrSelected = false;
      // selectedTravellerRef.current.selectedSsrCode = "";
      // wheelChairSsr.current = undefined;
      // setTravellers(list);
    }
    setShowSpecialAssistance(false);
  };

  const handleTermsConditions = () => {
    setShowBagTermsDialog(true);
  };

  const handleConfirmBooking = async (type) => {
    setIsLoading(true);
    setIsBookingClicked(true);
    const travellersList = [...travellers];
    let isError = false;
    for (let i = 0; i < travellersList.length; i++) {
      if (
        travellersList[i].first_name === undefined ||
        travellersList[i].first_name === '' ||
        travellersList[i].first_name.trim() === '' ||
        travellersList[i].first_name.trim().length < 2 ||
        NAME_REGEX.test(travellersList[i].first_name) === false ||
        travellersList[i].last_name === undefined ||
        travellersList[i].last_name === '' ||
        travellersList[i].last_name.trim() === '' ||
        travellersList[i].last_name.trim().length < 1 ||
        NAME_REGEX.test(travellersList[i].last_name) === false ||
        travellersList[i].title === ''
      ) {
        isError = true;
        setIsLoading(false);
      }
      if (
        isDobMandatoryForPax(travellersList[i].type) &&
        travellersList[i].dob === ''
      ) {
        isError = true;
        setIsLoading(false);
      }
    }
    if (
      leademail === undefined ||
      leademail === '' ||
      EMAIL_REGEX.test(leademail) === false ||
      leadmobile === undefined ||
      leadmobile === '' ||
      /^[5-9]\d{9}$/gi.test(leadmobile) === false
    ) {
      isError = true;
      setIsLoading(false);
    }
    travellersList.forEach((trav) => {
      delete trav.gender;
    });
    if (gst.gstcompany !== '' || gst.gstemail !== '' || gst.gstnumber !== '') {
      if (/^[a-zA-Z0-9]*$/gi.test(gst.gstnumber) === false) {
        isError = true;
        setGstValidationError(true);
        setIsLoading(false);
      }
    }
    if (isError) {
      setValidationError(true);
      setActiveTab(PAX);
      scrollToTop();
      return false;
    }
    let hasDifferentMarkup = false;
    travellersList.forEach((traveller, index) => {
      if (traveller.type !== 'Infant') {
        let markValue = tempMarkupList[index].tax_amount;
        if (markValue === '') {
          markValue = 0;
        }
        if (markValue !== '') {
          markValue = Number(markValue);
        }
        if (traveller.additional_taxhc !== markValue) {
          hasDifferentMarkup = true;
        }
      }
    });
    if (hasDifferentMarkup) {
      setIsLoading(false);
      setAlert({
        title: 'Additional Markup',
        description: 'Unsaved markup please apply',
        variant: 'error',
      });
      // scrollToTop();
      return false;
    }
    const response = await getAgentBalanceApi();
    if (response.ApiStatus.Status === 'OK') {
      const { Result = {} } = response.ApiStatus;
      const { UserAccount = {} } = Result;
      walletBalanceRef.current =
        UserAccount.Balance + UserAccount.CreditLimit - UserAccount.Due;
    }
    if (type === 'book') {
      setShowConfirmationDialog(true);
    }
    if (type === 'hold') {
      setShowConfirmHoldDialog(true);
    }
    setIsLoading(false);
  };

  const getUserSsr = (traveller, travellerIndex) => {
    const sectors = Object.keys(userSelectedSsrRows);
    let ssrStr = '';
    sectors.forEach((sector) => {
      const filteredMealRows = userSelectedSsrRows[sector].mealRows.filter(
        (mr) => mr.travellerIndex === travellerIndex,
      );
      filteredMealRows.forEach((row) => {
        if (row.ssrcode !== '') {
          ssrStr += `${formattedMessage('meal')}: ${row.ssrname}, `;
        }
      });
      const filteredBaggageRows = userSelectedSsrRows[
        sector
      ].baggageRows.filter((mr) => mr.travellerIndex === travellerIndex);
      filteredBaggageRows.forEach((row) => {
        if (row.ssrcode !== '') {
          ssrStr += `${formattedMessage('baggage')}: ${
            userSelectedSsrRows[sector].baggageRows[travellerIndex].ssrname
          }, `;
        }
      });
      if (userSelectedSsrRows[sector].seatRows[travellerIndex].ssrcode !== '') {
        ssrStr += `${formattedMessage('seat')}: ${
          userSelectedSsrRows[sector].seatRows[travellerIndex].ssrcode
        }, `;
      }
      if (
        userSelectedSsrRows[sector].specialSsrRows[travellerIndex].ssrcode !==
        ''
      ) {
        ssrStr += `${formattedMessage('special_ssr')}: ${
          userSelectedSsrRows[sector].specialSsrRows[travellerIndex].ssrcode
        }, `;
      }
      if (
        userSelectedSsrRows[sector].specialAssistanceRows[travellerIndex]
          .ssrcode !== ''
      ) {
        ssrStr += `${formattedMessage('wheelchair')}: ${
          userSelectedSsrRows[sector].specialAssistanceRows[travellerIndex]
            .ssrname
        }, `;
      }
    });

    return ssrStr.substring(0, ssrStr.length - 1);
  };
  const checkValidName = (name) => {
    return name !== '' && /^[a-zA-Z ]*$/.test(name) === false;
  };
  const checkValiGstNumber = (name) => {
    return name !== '' && /^[a-zA-Z0-9]*$/.test(name) === false;
  };

  const checkValidMobileNumber = () => {
    return leadmobile !== '' && /^[5-9]\d{9}$/gi.test(leadmobile) === false;
  };

  const checkValidEmailAddress = () => {
    return leademail !== '' && EMAIL_REGEX.test(leademail) === false;
  };

  const checkEmailAddress = (email) => {
    return email !== '' && EMAIL_REGEX.test(email) === false;
  };

  const getSelectedMeals = (userMealRows, index) => {
    const filterdMeals = userMealRows.filter(
      (row) => row.travellerIndex === index && row.ssrname !== '',
    );

    return filterdMeals.length === 0 ? (
      formattedMessage('select_meal')
    ) : (
      <ul className="selected-meals">
        {filterdMeals.map((meal, fmi) => (
          <li key={fmi}>
            <span>
              {meal.ssrname} • {formatCurrency(meal.ssr_chargeableamount)}
            </span>
            <AppIconButton
              onClick={() =>
                handleRemoveMeal(
                  meal,
                  index,
                  `${meal.origin} - ${meal.destination}`,
                )
              }
              variant="secondary"
            >
              <MdClose />
            </AppIconButton>
          </li>
        ))}
      </ul>
    );
  };

  const getSelectedSpecailSsr = (userSsrRows, index) => {
    const filteredSsrs = userSsrRows.filter(
      (row) => row.travellerIndex === index && row.ssrname !== '',
    );

    return filteredSsrs.length === 0 ? (
      formattedMessage('select_special_ssr')
    ) : (
      <ul className="selected-meals">
        {filteredSsrs.map((specail, fmi) => (
          <li key={fmi}>
            <span>
              {specail.ssrname} • {formatCurrency(specail.ssr_chargeableamount)}
            </span>
            <AppIconButton
              onClick={() =>
                handelRemoveSpecialSsr(
                  specail,
                  index,
                  `${specail.origin} - ${specail.destination}`,
                )
              }
              variant="secondary"
            >
              <MdClose />
            </AppIconButton>
          </li>
        ))}
      </ul>
    );
  };

  const handleOpenFareRules = async (key) => {
    setIsLoading(true);
    const response = await getFareRulesApi(key, '', domInt);
    if (
      response &&
      response.wsstatus &&
      response.wsstatus.status === 'OK' &&
      response.wsstatus.statusCode === '200'
    ) {
      setFareRulesHtml(JSON.parse(response.farerules_html).html);
      setIsOpenFareRulesDialog(true);
    } else if (
      response &&
      response.ApiStatus &&
      response.ApiStatus.Status === 'OK'
    ) {
      if (response.ApiStatus.Result.hasOwnProperty('AllFareRules')) {
        setFareRulesHtml(response.ApiStatus.Result.AllFareRules.Rule);
      } else {
        setFareRulesHtml(response.ApiStatus.Result.Rule);
      }
      setIsOpenFareRulesDialog(true);
    }
    setIsLoading(false);
  };

  const getSelectedSeat = (ssrRow, index, sector) => {
    return (
      <div className="d-flex flex-column">
        <span>
          {ssrRow.passenger_fname !== ''
            ? `${ssrRow.passenger_title} ${ssrRow.passenger_fname} ${ssrRow.passenger_lname}`
            : `${formattedMessage('traveller')} ${index + 1}`}
        </span>
        {ssrRow.ssrcode === '' ? (
          <small className="traveller-name__subheading">
            {formattedMessage('select_seat')}
          </small>
        ) : (
          <div className="d-flex gap-2 selected-seats align-items-center">
            <small className="traveller-name__subheading">
              {`${ssrRow.ssrcode} • ${formatCurrency(
                ssrRow.ssr_chargeableamount,
              )}`}
            </small>{' '}
            <AppIconButton
              onClick={() => handleRemoveSeat(ssrRow, sector)}
              variant="secondary"
            >
              <MdClose />
            </AppIconButton>
          </div>
        )}
      </div>
    );
  };

  const handleNomineeDetails = (event, index) => {
    const { name, value } = event.target;
    const list = [...travellers];
    list[index][name] = value;
    setTravellers(list);
  };

  // const handleTravelInsuranceSelection = (isSelected) => {
  //   const isChanged = hasTravelInsurance !== isSelected;
  //   const insuranceAmount = eligiblePaxForTravelInsurance * 200;
  //   if (isChanged) {
  //     let totFare = fareSummaryRef.current.totalFare;
  //     let totalNet = fareSummaryRef.current.totalAmountToShow;
  //     if (isSelected) {
  //       totFare = totFare + insuranceAmount;
  //       totalNet = totalNet + insuranceAmount;
  //     } else {
  //       totFare = totFare - insuranceAmount;
  //       totalNet = totalNet - insuranceAmount;
  //       const list = [...travellers];
  //       list.forEach((pax) => (pax.beneficiaryname = ''));
  //       setTravellers(list);
  //     }
  //     fareSummaryRef.current.totalFare = totFare;
  //     fareSummaryRef.current.totalAmountToShow = totalNet;
  //     setHasTravelInsurance(isSelected);
  //   }
  // };

  const handleAddMarkupForPax = (event, index) => {
    const { name, value } = event.target;
    const numValue = value.replace(/[^0-9]/g, '');
    const list = [...tempMarkupList];
    list[index][name] = numValue;
    setTempMarkupList(list);
  };

  const handleMarkupAddition = () => {
    const prevMarkUp = fareSummaryRef.current.AdditionalMarkupToShow;
    const list = [...tempMarkupList];
    list.forEach((pax) => {
      if (pax.tax_amount === '') {
        pax.tax_amount = 0;
      } else {
        const numValue = Number(pax.tax_amount);
        pax.tax_amount = numValue;
      }
    });
    let markUpValue = 0;
    list.forEach((pax) => {
      markUpValue += pax.tax_amount;
    });
    let totFare = fareSummaryRef.current.totalFare - prevMarkUp;
    totFare += markUpValue;
    fareSummaryRef.current.AdditionalMarkupToShow = markUpValue;
    fareSummaryRef.current.totalFare = totFare;
    const paxList = [...travellers];
    paxList.forEach((pax, index) => {
      pax.additional_taxhc = list[index].tax_amount;
    });
    setTempMarkupList(list);
    setTravellers(paxList);
    setAdditionalMarkup(markUpValue);
    setShowMarkup(true);
    setAlert({
      title: 'Additional Markup',
      description: 'Successfully Added Markup',
      variant: 'success',
    });
  };
  const handleRefClick = (ref) => {
    scrollToTop();
  };

  const handleOnFlightDetailsClick = () => {
    // setIsFlightDetailsCompleted(true);
    handleRefClick(targetRefs.flightDetails);
    setActiveTab(FLIGHT_DETAILS);
  };

  const handleFlightDetailsContinue = () => {
    setIsFlightDetailsCompleted(true);
    setActiveTab(PAX);
    handleRefClick(targetRefs.pax);
  };
  const handlePaxContinue = () => {
    setIsBookingClicked(true);
    const travellersList = [...travellers];
    let isError = false;
    for (let i = 0; i < travellersList.length; i++) {
      if (
        travellersList[i].first_name === undefined ||
        travellersList[i].first_name === '' ||
        travellersList[i].first_name.trim() === '' ||
        travellersList[i].first_name.trim().length < 2 ||
        NAME_REGEX.test(travellersList[i].first_name) === false ||
        travellersList[i].last_name === undefined ||
        travellersList[i].last_name === '' ||
        travellersList[i].last_name.trim() === '' ||
        travellersList[i].last_name.trim().length < 1 ||
        NAME_REGEX.test(travellersList[i].last_name) === false ||
        travellersList[i].title === ''
      ) {
        isError = true;
        setIsLoading(false);
      }
      if (
        isDobMandatoryForPax(travellersList[i].type) &&
        travellersList[i].dob === ''
      ) {
        isError = true;
        setIsLoading(false);
      }
    }
    if (
      leademail === undefined ||
      leademail === '' ||
      EMAIL_REGEX.test(leademail) === false ||
      leadmobile === undefined ||
      leadmobile === '' ||
      /^[5-9]\d{9}$/gi.test(leadmobile) === false
    ) {
      isError = true;
      setIsLoading(false);
    }
    travellersList.forEach((trav) => {
      delete trav.gender;
    });
    if (gst.gstcompany !== '' || gst.gstemail !== '' || gst.gstnumber !== '') {
      if (/^[a-zA-Z0-9]*$/gi.test(gst.gstnumber) === false) {
        isError = true;
        setGstValidationError(true);
        setIsLoading(false);
      }
    }
    if (isError) {
      setValidationError(true);
      return false;
    }
    setIsPaxCompleted(true);
    setActiveTab(SSR);
    handleRefClick(targetRefs.ssr);
  };
  const handleSsrContinue = () => {
    setIsSSRCompleted(true);
    setActiveTab(PG);
    handleRefClick(targetRefs.pg);
  };

  const handleSavePaxDetails = async (index) => {
    setIsLoading(true);
    const selectedPax = travellers[index];
    if (
      selectedPax.first_name === '' ||
      selectedPax.last_name === '' ||
      selectedPax.title === '' ||
      NAME_REGEX.test(selectedPax.first_name) === false ||
      NAME_REGEX.test(selectedPax.last_name) === false ||
      leademail === undefined ||
      leademail === '' ||
      EMAIL_REGEX.test(leademail) === false ||
      leadmobile === undefined ||
      leadmobile === '' ||
      /^[5-9]\d{9}$/gi.test(leadmobile) === false
    ) {
      setAlert({
        variant: 'error',
        title: 'Save Pax Details',
        description: 'Enter valid pax details',
      });
      setIsLoading(false);
      return false;
    }
    const req = {
      corporate_name: `${selectedPax.first_name} ${selectedPax.last_name}`,
      isidentity: false,
      isemployee: true,
      title: selectedPax.title,
      first_name: selectedPax.first_name,
      last_name: selectedPax.last_name,
      dob: '',
      iscorporate_traveller: true,
      isleisure_traveller: true,
      relation: 'self',
      isfamily_member: false,
      system_roleid: 7,
      maritalstatus: 'noselection',
      user_roleid: 'dummy',
      corporate_role: 0,
      grade: '',
      department: '',
      sbtenabled: false,
      employeeid: '',
      password: '',
      phone: leadmobile,
      email: leademail,
      mobile: leadmobile,
      profile_name: selectedPax.first_name,
      pancard: 'NA',
      city: 'NA',
      state: 'NA',
      country: 'NA',
      status: 'active',
      address1: 'NA',
      pincode: 'NA',
    };
    const response = await savePaxDetailsApi(req, getUserAgentId());
    if (response && response.Root && response.Root.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Save Pax Details',
        description: 'Pax details saved successfully',
      });
      const paxIndices = [...savedPaxIndex];
      paxIndices.push(index);
      setSavedPaxIndex(paxIndices);
    } else {
      setAlert({
        variant: 'error',
        title: 'Save Pax Details',
        description: 'Failed to save pax details',
      });
    }
    setIsLoading(false);
  };

  const handleClosePostBookingPopup = () => {
    navigate('/');
  };
  const handleNavigateToTicketPage = (fbId) => {
    const url = `/flight/ticket/${fbId}`;
    window.open(url, '_blank');
  };

  const getMeal = (sector, travellerIndex) => {
    if (userSelectedSsrRows[sector].mealRows[travellerIndex].ssrcode !== '') {
      return userSelectedSsrRows[sector].mealRows[travellerIndex].ssrname;
    }
    return '';
  };

  const getSeatNo = (sector, travellerIndex) => {
    if (userSelectedSsrRows[sector].seatRows[travellerIndex].ssrcode !== '') {
      return userSelectedSsrRows[sector].seatRows[travellerIndex].ssrcode;
    }
    return '';
  };
  const getExcessBaggage = (sector, travellerIndex) => {
    let filteredBaggageRows = [];
    filteredBaggageRows = userSelectedSsrRows[sector].baggageRows.filter(
      (mr) => mr.travellerIndex === travellerIndex,
    );
    const bags = [];
    const selectedBags = filteredBaggageRows.filter((x) => x.ssrcode !== '');
    // if (selectedBags.length === 0) {
    //   const isOnward = onwardFlightSectorsRef.current.indexOf(sector) > -1;
    //   if (isOnward) {
    //     const filteredBaggageRows = userSelectedSsrRows[
    //       `${originRef.current} - ${destinationRef.current}`
    //     ].baggageRows.filter((mr) => mr.travellerIndex === travellerIndex);
    //   }
    //   if (isReturn) {
    //     filteredBaggageRows = userSelectedSsrRows[
    //       `${destinationRef.current} - ${originRef.current}`
    //     ].baggageRows.filter((mr) => mr.travellerIndex === travellerIndex);
    //   }
    // }
    filteredBaggageRows.forEach((row) => {
      if (row.ssrcode !== '') {
        bags.push(row.ssrname);
      }
    });
    return bags.join(',');
  };

  // console.log('userSelectedSsrRows', userSelectedSsrRows);
  // console.log('flightlegs with seat', flightLegsWithSeatsRef.current);

  const getOtherSsr = (sector, travellerIndex) => {
    let filteredSpecialSsrRows = [];
    // let filteredSpecialAssistanceRows = [];
    filteredSpecialSsrRows = userSelectedSsrRows[sector].specialSsrRows.filter(
      (mr) => mr.travellerIndex === travellerIndex,
    );
    // filteredSpecialAssistanceRows = userSelectedSsrRows[sector].specialAssistanceRows.filter(
    //   (mr) => mr.travellerIndex === travellerIndex,
    // );
    const specialSSr = [];
    const selectedSplCodes = filteredSpecialSsrRows.filter(
      (x) => x.ssrcode !== '',
    );
    // if (selectedSplCodes.length === 0) {
    //   const isOnward = onwardFlightSectorsRef.current.indexOf(sector) > -1;
    //   const isReturn = returnFlightSectorsRef.current.indexOf(sector) > -1;
    //   if (isOnward) {
    //     filteredSpecialSsrRows = userSelectedSsrRows[
    //       `${originRef.current} - ${destinationRef.current}`
    //     ].specialSsrRows.filter((mr) => mr.travellerIndex === travellerIndex);
    //   }
    //   if (isReturn) {
    //     filteredSpecialSsrRows = userSelectedSsrRows[
    //       `${destinationRef.current} - ${originRef.current}`
    //     ].specialSsrRows.filter((mr) => mr.travellerIndex === travellerIndex);
    //   }
    // }
    filteredSpecialSsrRows.forEach((row) => {
      if (row.ssrcode !== '') {
        specialSSr.push(row.ssrname);
      }
    });

    // const filteredWheelRows = userSelectedSsrRows[
    //   sector
    // ].specialAssistanceRows.filter(
    //   (mr) => mr.travellerIndex === travellerIndex,
    // );
    // if (filteredWheelRows.length !== 0) {
    //   filteredWheelRows.forEach((ele) => {
    //     specialSSr.push(ele.ssrcode);
    //   });
    // }

    // const directFilteredWheelRows = userSelectedSsrRows[
    //   directSector
    // ].specialAssistanceRows.filter(
    //   (mr) => mr.travellerIndex === travellerIndex,
    // );
    // if (directFilteredWheelRows.length !== 0) {
    //   directFilteredWheelRows.forEach((ele) => {
    //     specialSSr.push(ele.ssrcode);
    //   });
    // }
    return specialSSr.join(',');
  };

  const getSectorWithTripNumber = (sector) => {
    return (
      <div className="d-flex flex-column align-items-center">
        <span style={{ fontSize: '12px', fontWeight: '500' }}>
          {sector.split(' - ')[0]} - {sector.split(' - ')[1]}
        </span>
        <span style={{ fontSize: '10px', fontWeight: '300' }}>
          Trip - {parseInt(sector.split(' - ')[2], 10) + 1}
        </span>
      </div>
    );
  };

  // console.log('user selected ssr rows', userSelectedSsrRows);
  // console.log('SearchRef', searchArrayRef.current);
  // console.log('flight Sector', rePriceResponse);

  return (
    <section className="flight-booking-page pb-2">
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => {
            setAlert(undefined);
          }}
        />
      )}
      {isLoading && <AppLoading isLoading={isLoading} />}
      <div className="flight-booking-page_header">
        <div className="flight-booking-page_header_container d-flex justify-content-end flex-sm-row flex-column">
          <div className="d-flex flex-sm-row flight-booking-page_stepper justify-content-between px-sm-0 px-2">
            <div className="booking-counter-background my-1">
              <CountdownTimer
                targetDate={elevenMinFromNowInMilli}
                continueBtnText={formattedMessage('back_to_search_results_btn')}
                continueRoutePath="searchResults"
              />
            </div>
            <div
              onClick={handleOnFlightDetailsClick}
              className={`flight-booking-page_stepper_step ${
                isFlightDetailsCompleted ? 'completed-step' : ''
              }  ${activeTab === FLIGHT_DETAILS ? 'active-step' : ''} `}
            >
              {isFlightDetailsCompleted ? (
                activeTab === FLIGHT_DETAILS ? (
                  <MdCheckCircleOutline />
                ) : (
                  <MdCheckCircle />
                )
              ) : (
                <div className="flight-booking-page_stepper_step_count">1</div>
              )}
              <div className="flight-booking-page_stepper_step_name">
                Flight Details
              </div>
            </div>
            <div
              onClick={handleFlightDetailsContinue}
              className={`flight-booking-page_stepper_step ${
                isPaxCompleted ? 'completed-step' : ''
              }  ${activeTab === PAX ? 'active-step' : ''} `}
            >
              {isPaxCompleted ? (
                activeTab === PAX ? (
                  <MdCheckCircleOutline />
                ) : (
                  <MdCheckCircle />
                )
              ) : (
                <div className="flight-booking-page_stepper_step_count">2</div>
              )}
              <div className="flight-booking-page_stepper_step_name">
                Pax Details
              </div>
            </div>
            <div
              onClick={handlePaxContinue}
              className={`flight-booking-page_stepper_step ${
                isSSRCompleted ? 'completed-step' : ''
              }  ${activeTab === SSR ? 'active-step' : ''} `}
            >
              {isSSRCompleted ? (
                activeTab === SSR ? (
                  <MdCheckCircleOutline />
                ) : (
                  <MdCheckCircle />
                )
              ) : (
                <div className="flight-booking-page_stepper_step_count">3</div>
              )}
              <div className="flight-booking-page_stepper_step_name">
                Addons
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flight-booking-page_header-space" />
      <section className="flight-booking-page_container">
        <Row className="spacing-8">
          <Col lg={9} md={12} sm={12} xs={12}>
            <div
              className="flight-booking-page_content p-3"
              ref={targetRefs.flightDetails}
            >
              <div className="flight-booking-page_flight-details">
                <div className="flight-booking-page_flight-details_journey-details d-flex justify-content-between align-items-center">
                  <div>
                    {searchRequest.origin.split(':').map((d, index) => (
                      <div
                        className={`fs-16 fw-600 ${
                          activeTab === FLIGHT_DETAILS ? 'd-none' : ''
                        }`}
                        key={d}
                      >{`${
                        searchRequest.originlocations
                          .split(':')
                          [index].split(',')[0]
                      } (${d}) -> ${
                        searchRequest.destinationlocations
                          .split(':')
                          [index].split(',')[0]
                      } (${
                        searchRequest.destination.split(':')[index]
                      }) | ${formatDate(
                        getNewDate(getOnwardDate(index)),
                        DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                      )}`}</div>
                    ))}
                  </div>
                  <div className="d-flex align-items-center">
                    <AppLink
                      linkText="Back to search results"
                      variant="primary"
                      className="fw-600"
                      onClick={() => navigate(-1)}
                    />
                    {isFlightDetailsCompleted && (
                      <div>
                        {activeTab === FLIGHT_DETAILS ? (
                          <AppIconButton
                            variant="transparent"
                            onClick={() => setActiveTab(PAX)}
                            className="fs-3"
                          >
                            <MdKeyboardArrowUp />
                          </AppIconButton>
                        ) : (
                          <AppIconButton
                            variant="transparent"
                            onClick={() => setActiveTab(FLIGHT_DETAILS)}
                            className="fs-3"
                          >
                            <MdKeyboardArrowDown />
                          </AppIconButton>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {showFlightDetails && activeTab === FLIGHT_DETAILS && (
                  <Accordion>
                    {searchRequest.origin.split(':').map((d, index) => {
                      const date = getDateWithHypends(
                        searchRequest.onwarddate.split(':')[index],
                      );
                      const sec = `${d} - ${
                        searchRequest.destination.split(':')[index]
                      } - ${date}`;
                      return (
                        <Accordion.Item key={sec} eventKey={`${index}`}>
                          <Accordion.Header>
                            <div className="d-flex flex-1 justify-content-between align-items-center pe-2 flex-sm-row flex-column">
                              <div className="fs-16 fw-600" key={d}>{`${
                                searchRequest.originlocations
                                  .split(':')
                                  [index].split(',')[0]
                              } (${d}) -> ${
                                searchRequest.destinationlocations
                                  .split(':')
                                  [index].split(',')[0]
                              } (${
                                searchRequest.destination.split(':')[index]
                              }) | ${formatDate(
                                getNewDate(getOnwardDate(index)),
                                DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                              )}`}</div>
                              <AppLink
                                linkText="Fare Rules"
                                variant="secondary"
                                onClick={() =>
                                  handleOpenFareRules(selectedFareKeys[sec])
                                }
                              />
                            </div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <SelectedFlightDetails
                              selectedFlight={selectedFlight[sec]}
                              searchRequest={getSearchRequestForSector(sec)}
                            />
                          </Accordion.Body>
                        </Accordion.Item>
                      );
                    })}
                  </Accordion>
                )}
              </div>
            </div>
            {activeTab === FLIGHT_DETAILS && (
              <div className="m-2 mb-0 d-flex justify-content-end">
                <AppButton
                  btnText="Continue"
                  variant="outlined"
                  onClick={handleFlightDetailsContinue}
                />
              </div>
            )}
            <div className="separator" ref={targetRefs.insurance} />
            <div className="separator" />
            <div className="flight-booking-page_content" ref={targetRefs.pax}>
              <div className="d-flex justify-content-between align-items-center">
                <div className="flight-booking-page_title d-flex flex-column">
                  {formattedMessage('traveller_details')}
                  {isPaxCompleted && (
                    <div>
                      {travellers.map((traveller, index) => (
                        <div key={index} className="fs-14 grey-color fw-300">
                          {traveller.first_name !== '' &&
                            `${index + 1}) ${traveller.title} ${
                              traveller.first_name
                            } ${traveller.last_name}`}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {isPaxCompleted && (
                  <div className="pe-sm-3 pe-0">
                    {activeTab === PAX ? (
                      <AppIconButton
                        variant="transparent"
                        onClick={() => setActiveTab(PG)}
                        className="fs-3"
                      >
                        <MdKeyboardArrowUp />
                      </AppIconButton>
                    ) : (
                      <AppIconButton
                        variant="transparent"
                        onClick={() => setActiveTab(PAX)}
                        className="fs-3"
                      >
                        <MdKeyboardArrowDown />
                      </AppIconButton>
                    )}
                  </div>
                )}
              </div>
              {activeTab === PAX && (
                <div className="p-3 pt-0">
                  <p className="contact-details__subtitle mt-2">
                    {formattedMessage('contact_information')} (
                    {formattedMessage(
                      'your_ticket_and_flight_info_will_sent_here',
                    )}
                    )
                  </p>
                  <Row className="spacing-8 my-2">
                    <Col lg={3} md={3} sm={3} xs={12}>
                      <AppSelect
                        className="country-codes-input"
                        name="countryCode"
                        id="countryCode"
                        label={formattedMessage('country_code')}
                        placeholder=""
                        required
                        selectedValue={countryCode}
                        options={countryCodeOptions}
                        isClearable={false}
                        errorText={
                          validationError &&
                          isBookingClicked &&
                          formattedMessage('country_code_validation')
                        }
                        onSelect={(value) =>
                          value !== null
                            ? setCountryCode(value.value)
                            : setCountryCode('')
                        }
                      />
                    </Col>
                    <Col lg={3} md={3} sm={3} xs={12}>
                      <AppTextInput
                        className="contact-input"
                        name="leadmobile"
                        id="leadmobile"
                        required
                        label={formattedMessage('mobile_number')}
                        value={leadmobile}
                        errorText={
                          validationError &&
                          isBookingClicked &&
                          formattedMessage('mobile_number_validation')
                        }
                        onChange={(event) => setLeadmobile(event.target.value)}
                      />
                      {checkValidMobileNumber() && (
                        <small className="app-error-text">
                          {formattedMessage('enter_valid_mobile_number')}
                        </small>
                      )}
                    </Col>
                    <Col lg={3} md={3} sm={3} xs={12}>
                      <AppTextInput
                        className="contact-input"
                        name="leademail"
                        id="leademail"
                        required
                        label={formattedMessage('email_id')}
                        value={leademail}
                        errorText={
                          validationError &&
                          isBookingClicked &&
                          formattedMessage('email_id')
                        }
                        onChange={(event) => setLeademail(event.target.value)}
                      />
                      {checkValidEmailAddress() && (
                        <small className="app-error-text">
                          {formattedMessage('email_id_validation')}
                        </small>
                      )}
                    </Col>
                  </Row>
                  <span className="primary-color my-2 fs-16 fw-600">
                    {formattedMessage('traveller_details')}
                  </span>
                  {travellers.map((traveller, index) => (
                    <div key={index}>
                      <div className="traveller-count p-2 ps-3">
                        {traveller.type}
                      </div>
                      <div className="saved-travellers">
                        <Row className="spacing-8 my-3">
                          <Col lg={3} md={3} sm={3} xs={12}>
                            <AppSelect
                              label={formattedMessage('title_select')}
                              required
                              className="title-select"
                              name="title"
                              id="title"
                              placeholder=""
                              errorText={
                                validationError &&
                                isBookingClicked &&
                                formattedMessage('title_seelect_validation')
                              }
                              options={
                                traveller.type === 'Adult'
                                  ? TITLE_OPTIONS
                                  : OTHER_TITLE_OPTIONS
                              }
                              selectedValue={traveller.title}
                              onSelect={(event) =>
                                handleTitleSelect(event, index)
                              }
                            />
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={12}>
                            <AppTextInput
                              className="traveller-input"
                              name="first_name"
                              id="first_name"
                              required
                              label={formattedMessage('first_name')}
                              value={traveller.first_name}
                              errorText={
                                isBookingClicked &&
                                validationError &&
                                formattedMessage('first_name_validation')
                              }
                              onChange={(event) =>
                                handleTextInputChange(event, index)
                              }
                            />
                            {validationError &&
                              isBookingClicked &&
                              traveller.first_name !== undefined &&
                              traveller.first_name.trim() !== '' &&
                              traveller.first_name.trim().length < 2 && (
                                <small className="app-error-text">
                                  {formattedMessage(
                                    'first_name_length_validation',
                                  )}
                                </small>
                              )}
                            {checkValidName(traveller.first_name) && (
                              <small className="app-error-text">
                                {formattedMessage('name_validation')}
                              </small>
                            )}
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={12}>
                            <AppTextInput
                              className="traveller-input"
                              name="last_name"
                              id="last_name"
                              required
                              label={formattedMessage('last_name')}
                              errorText={
                                validationError &&
                                isBookingClicked &&
                                formattedMessage('last_name_validation')
                              }
                              value={traveller.last_name}
                              onChange={(event) =>
                                handleTextInputChange(event, index)
                              }
                            />
                            {validationError &&
                              isBookingClicked &&
                              traveller.last_name !== undefined &&
                              traveller.last_name.trim() !== '' &&
                              traveller.last_name.trim().length < 1 && (
                                <small className="app-error-text">
                                  {formattedMessage(
                                    'last_name_length_validation',
                                  )}
                                </small>
                              )}
                            {checkValidName(traveller.last_name) && (
                              <small className="app-error-text">
                                {formattedMessage('name_validation')}
                              </small>
                            )}
                          </Col>
                          {isDobMandatoryForPax(traveller.type) && (
                            <Col lg={3} md={3} sm={3} xs={12}>
                              <AppDatePicker
                                label={formattedMessage('dob')}
                                className="app-date-picker"
                                customClassName={`position-relative flight-booking-picker ${
                                  validationError &&
                                  isBookingClicked &&
                                  isDobMandatoryForPax(traveller.type) &&
                                  traveller.dob === ''
                                    ? 'app-error-text-border'
                                    : ''
                                }`}
                                placeholder=""
                                showMonthDropdown
                                showYearDropdown
                                monthsShown={1}
                                dropdownMode="select"
                                disabledKeyboardNavigation
                                required={isDobMandatoryForPax(traveller.type)}
                                minDate={getDOBMinDate(traveller.type)}
                                maxDate={getDOBMaxDate(traveller.type)}
                                selectedDate={
                                  traveller.dob !== '' &&
                                  getNewDate(traveller.dob)
                                }
                                onChange={(date) =>
                                  handleTextInputChange(
                                    {
                                      target: {
                                        name: 'dob',
                                        value: formatDate(
                                          getNewDate(date),
                                          API_DATE_FORMAT,
                                        ),
                                      },
                                    },
                                    index,
                                  )
                                }
                                labelClassName="booking-date-label"
                              />
                              {validationError &&
                                isBookingClicked &&
                                isDobMandatoryForPax(traveller.type) &&
                                traveller.dob === '' && (
                                  <small className="app-error-text">
                                    {formattedMessage('dob_validation')}
                                  </small>
                                )}
                            </Col>
                          )}
                          {rePriceResponse.domint === 'international' && (
                            <Col lg={3} md={3} sm={3} xs={12}>
                              <AppSelect
                                label="Gender"
                                className="title-select"
                                name="gender"
                                id="gender"
                                placeholder=""
                                options={GENDER_OPTIONS}
                                selectedValue={traveller.gender}
                                onSelect={(event) =>
                                  handleGenderSelect(event, index)
                                }
                                isClearable={false}
                              />
                            </Col>
                          )}
                          {traveller.type === 'Adult' && (
                            <Col lg={3} md={3} sm={3} xs={12}>
                              <AppTextInput
                                className="traveller-input"
                                name="frequent_flyer_number"
                                id="frequent_flyer_number"
                                label="Frequent Flyer Number"
                                value={traveller.frequent_flyer_number}
                                onChange={(event) =>
                                  handleTextInputChange(event, index)
                                }
                              />
                            </Col>
                          )}
                        </Row>
                        {rePriceResponse.domint === 'international' && (
                          <Row className="spacing-8 my-3">
                            <Col lg={3} md={3} sm={3} xs={12}>
                              <AppTextInput
                                className="traveller-input"
                                name="passport"
                                id="passport"
                                required
                                label={formattedMessage('passport_number')}
                                value={traveller.passport}
                                errorText={
                                  isBookingClicked &&
                                  validationError &&
                                  rePriceResponse.domint === 'international' &&
                                  formattedMessage('passport_number_validation')
                                }
                                onChange={(event) =>
                                  handleTextInputChange(event, index)
                                }
                              />
                            </Col>

                            <Col lg={3} md={3} sm={3} xs={12}>
                              <AppDatePicker
                                label={formattedMessage('passport_issue_date')}
                                className="app-date-picker"
                                customClassName={`position-relative flight-booking-picker ${
                                  validationError &&
                                  isBookingClicked &&
                                  rePriceResponse.domint === 'international' &&
                                  traveller.passport_dateofissue === ''
                                    ? 'app-error-text-border'
                                    : ''
                                }`}
                                placeholder=""
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                disabledKeyboardNavigation
                                required
                                maxDate={getNewDate(TODAY_DATE)}
                                selectedDate={
                                  traveller.passport_dateofissue !== '' &&
                                  getNewDate(traveller.passport_dateofissue)
                                }
                                onChange={(date) =>
                                  handleTextInputChange(
                                    {
                                      target: {
                                        name: 'passport_dateofissue',
                                        value: formatDate(
                                          getNewDate(date),
                                          API_DATE_FORMAT,
                                        ),
                                      },
                                    },
                                    index,
                                  )
                                }
                                labelClassName="booking-date-label"
                              />
                              {validationError &&
                                isBookingClicked &&
                                rePriceResponse.domint === 'international' &&
                                traveller.passport_dateofissue === '' && (
                                  <small className="app-error-text">
                                    {formattedMessage(
                                      'date_of_issue_validation',
                                    )}
                                  </small>
                                )}
                            </Col>
                            <Col lg={3} md={3} sm={3} xs={12}>
                              <AppDatePicker
                                label={formattedMessage('passport_expiry')}
                                className="app-date-picker"
                                customClassName={`position-relative flight-booking-picker ${
                                  validationError &&
                                  isBookingClicked &&
                                  rePriceResponse.domint === 'international' &&
                                  traveller.passport_dateofexpiry === ''
                                    ? 'app-error-text-border'
                                    : ''
                                }`}
                                placeholder=""
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                disabledKeyboardNavigation
                                required
                                minDate={getNewDate(TODAY_DATE)}
                                selectedDate={
                                  traveller.passport_dateofexpiry !== '' &&
                                  getNewDate(traveller.passport_dateofexpiry)
                                }
                                onChange={(date) =>
                                  handleTextInputChange(
                                    {
                                      target: {
                                        name: 'passport_dateofexpiry',
                                        value: formatDate(
                                          getNewDate(date),
                                          API_DATE_FORMAT,
                                        ),
                                      },
                                    },
                                    index,
                                  )
                                }
                                labelClassName="booking-date-label"
                              />
                              {validationError &&
                                isBookingClicked &&
                                rePriceResponse.domint === 'international' &&
                                traveller.passport_dateofexpiry === '' && (
                                  <small className="app-error-text">
                                    {formattedMessage(
                                      'date_of_expiry_validation',
                                    )}
                                  </small>
                                )}
                            </Col>
                            <Col lg={3} md={3} sm={3} xs={12}>
                              <AppTextInput
                                className="traveller-input"
                                name="passport_placeofissue"
                                id="passport_placeofissue"
                                required
                                label={formattedMessage('passport_issue_place')}
                                value={traveller.passport_placeofissue}
                                errorText={
                                  isBookingClicked &&
                                  validationError &&
                                  rePriceResponse.domint === 'international' &&
                                  formattedMessage('passport_issue_place')
                                }
                                onChange={(event) =>
                                  handleTextInputChange(event, index)
                                }
                              />
                            </Col>
                          </Row>
                        )}
                        {hasWheelChairRows &&
                          traveller.type.toLowerCase() !== 'infant' && (
                            <div className="special-assistance-box mt-3">
                              <span className="pe-3">
                                {formattedMessage('special_assistance')}
                              </span>
                              <AppLink
                                isLink={false}
                                variant="primary"
                                onClick={() => handleSwitchChange(index)}
                                linkText={
                                  traveller.hasWheelChair
                                    ? formattedMessage('remove_btn')
                                    : formattedMessage('add')
                                }
                              />
                            </div>
                          )}
                      </div>
                      <div className="d-flex justify-content-between">
                        <div>
                          {savedPaxIndex.indexOf(index) > -1 ? (
                            <span className="green-color fs-12">Saved</span>
                          ) : (
                            <AppLink
                              linkText="Save Pax Details"
                              className="fs-12"
                              onClick={() => handleSavePaxDetails(index)}
                            />
                          )}
                        </div>
                        <div>
                          <AppLink
                            linkText="Select Passengers"
                            className="fs-12"
                            onClick={() => {
                              selectedCustomerRef.current = index;
                              setShowSelectPaxModal(true);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {activeTab === PAX && (
              <>
                <div className="separator" />
                <div className="flight-booking-page_content">
                  <div className="flight-booking-page_title">
                    {formattedMessage('gst_details_header')}
                  </div>
                  <div className="p-3">
                    <div className="d-flex flex-column flex-sm-row gap-3">
                      <div>
                        <AppTextInput
                          name="gstnumber"
                          value={gst.gstnumber}
                          label={formattedMessage('gst_number')}
                          errorText={
                            gstValidationError &&
                            formattedMessage('gst_number_validation')
                          }
                          onChange={handleGstChange}
                        />
                        {checkValiGstNumber(gst.gstnumber?.trim()) && (
                          <small className="app-error-text">
                            {formattedMessage('gst_number_validation')}
                          </small>
                        )}
                      </div>
                      <div>
                        <AppTextInput
                          name="gstcompany"
                          value={gst.gstcompany}
                          label={formattedMessage('company_name')}
                          errorText={
                            gstValidationError &&
                            formattedMessage('please_enter_gst_company')
                          }
                          onChange={handleGstChange}
                        />
                      </div>
                      <div>
                        <AppTextInput
                          name="gstemail"
                          value={gst.gstemail}
                          label={formattedMessage('company_email_address')}
                          errorText={
                            gstValidationError &&
                            formattedMessage('please_enter_gst_email_address')
                          }
                          onChange={handleGstChange}
                        />
                        {checkEmailAddress(gst.gstemail) && (
                          <small className="app-error-text">
                            {formattedMessage('company_email_address')}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m-2 mb-0 d-flex justify-content-end">
                  <AppButton
                    btnText="Continue"
                    variant="outlined"
                    onClick={handlePaxContinue}
                  />
                </div>
              </>
            )}
            {/* {(rePriceResponse.seatmapavailable ||
              rePriceResponse.ssravailable ||
              isGdsSearch) && ( */}
            <>
              <div className="separator" />
              <div
                className="flight-booking-page_content add-ons-section"
                ref={targetRefs.ssr}
              >
                <div className=" d-flex justify-content-between align-items-center">
                  <div className="flight-booking-page_title d-flex flex-column">
                    Add on ( optional )
                    {isSSRCompleted && (
                      <div className="fs-14 grey-color fw-300">
                        {travellers.map((traveller, index) => (
                          <div
                            key={index}
                            className="flight-booking-page_display-text"
                          >
                            <div className="fw-300 fs-12">
                              {getUserSsr(traveller, index)}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {isSSRCompleted && (
                    <div className="pe-sm-3 pe-0">
                      {activeTab === SSR ? (
                        <AppIconButton
                          variant="transparent"
                          onClick={() => setActiveTab(PG)}
                          className="fs-3"
                        >
                          <MdKeyboardArrowUp />
                        </AppIconButton>
                      ) : (
                        <AppIconButton
                          variant="transparent"
                          onClick={() => setActiveTab(SSR)}
                          className="fs-3"
                        >
                          <MdKeyboardArrowDown />
                        </AppIconButton>
                      )}
                    </div>
                  )}
                </div>
                {activeTab === SSR && (
                  <div className="d-flex flex-wrap">
                    {/* {rePriceResponse.seatmapavailable && ( */}
                    <div className="m-2 d-flex justify-content-center align-items-center">
                      <AppIconButton
                        onClick={() => handleAddAddOn(ADDONS.SEAT)}
                        variant="transparent"
                        className="p-2 flex-1 d-flex justify-content-center align-items-center fs-14 grey-color ssr-btn"
                      >
                        {isSeatSelected ? (
                          <div className=" d-flex justify-content-center align-items-center gap-1">
                            <MdChair className="primary-color" /> Edit Seat
                          </div>
                        ) : (
                          <div className=" d-flex justify-content-center align-items-center gap-1">
                            <MdChair className="primary-color" /> Seat Selection
                          </div>
                        )}
                      </AppIconButton>
                    </div>
                    {/* )} */}
                    {/* {(rePriceResponse.ssravailable || isGdsSearch) && ( */}
                    <>
                      <div className="m-2 d-flex justify-content-center align-items-center">
                        <AppIconButton
                          onClick={() => handleAddAddOn(ADDONS.MEALS)}
                          variant="transparent"
                          className="p-2 flex-1 d-flex justify-content-center align-items-center fs-14 grey-color ssr-btn"
                        >
                          {isMealSelected ? (
                            <div className=" d-flex justify-content-center align-items-center gap-1">
                              <MdOutlineFastfood className="primary-color" />{' '}
                              Edit Meal
                            </div>
                          ) : (
                            <div className=" d-flex justify-content-center align-items-center gap-1">
                              <MdOutlineFastfood className="primary-color" />{' '}
                              Add Meals
                            </div>
                          )}
                        </AppIconButton>
                      </div>
                      <div className="m-2 d-flex justify-content-center align-items-center">
                        <AppIconButton
                          onClick={() => handleAddAddOn(ADDONS.BAGGAGE)}
                          variant="transparent"
                          className="p-2 flex-1 d-flex justify-content-center align-items-center fs-14 grey-color ssr-btn"
                        >
                          {isBaggageSelected ? (
                            <div className=" d-flex justify-content-center align-items-center gap-1">
                              <MdLuggage className="primary-color" /> Edit
                              Baggage
                            </div>
                          ) : (
                            <div className=" d-flex justify-content-center align-items-center gap-1">
                              <MdLuggage className="primary-color" /> Add
                              Baggage
                            </div>
                          )}
                        </AppIconButton>
                      </div>
                      <div className="m-2 d-flex justify-content-center align-items-center">
                        <AppIconButton
                          onClick={() => handleAddAddOn(ADDONS.SPECIAL_SSR)}
                          variant="transparent"
                          className="p-2 flex-1 d-flex justify-content-center align-items-center fs-14 grey-color ssr-btn"
                        >
                          {isSpecialSsrSelected ? (
                            <div className=" d-flex justify-content-center align-items-center gap-1">
                              <MdList className="primary-color" /> Edit Other
                              SSR
                            </div>
                          ) : (
                            <div className=" d-flex justify-content-center align-items-center gap-1">
                              <MdList className="primary-color" /> Other SSR
                            </div>
                          )}
                        </AppIconButton>
                      </div>
                    </>
                    {/* )} */}
                  </div>
                )}
              </div>
              {activeTab === SSR && (
                <div className="m-2 mb-0 d-flex justify-content-end">
                  <AppButton
                    btnText="Continue"
                    variant="outlined"
                    onClick={handleSsrContinue}
                  />
                </div>
              )}
            </>
            {/* )} */}
            <div className="separator" />
            <div className="flight-booking-page_content" ref={targetRefs.pg}>
              <div className="flight-booking-page_title">Payment options</div>
              <div className="d-flex cursor-pointer">
                <div
                  className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                    paymentmode === 'cashcard' ? 'primary-color' : 'grey-color'
                  }`}
                  onClick={() => setPaymentMode('cashcard')}
                >
                  <CiWallet />
                  Wallet
                </div>
                {/* <div
                  className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                    paymentmode === 'creditcard'
                      ? 'primary-color'
                      : 'grey-color'
                  }`}
                  onClick={() => setPaymentMode('creditcard')}
                >
                  {' '}
                  <MdOutlineCreditCard /> Credit/Debit
                </div>
                <div
                  className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                    paymentmode === 'netbanking'
                      ? 'primary-color'
                      : 'grey-color'
                  }`}
                  onClick={() => setPaymentMode('netbanking')}
                >
                  <CiBank />
                  Netbanking
                </div>
                <div
                  className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                    paymentmode === 'upi' ? 'primary-color' : 'grey-color'
                  }`}
                  onClick={() => setPaymentMode('upi')}
                >
                  <CiBank />
                  UPI
                </div> */}
              </div>
            </div>
            <div className="separator" />
            <div className="flight-booking-page_content p-3 d-flex justify-content-between d-column d-md-row">
              <AppCheckBox
                labelText={formattedMessage(
                  'i_have_read_and_accept_terms_and_conditions',
                )}
                id="acceptTerms"
                name="acceptTerms"
                checked={acceptTerms}
                labelClassName="fs-12"
                onChange={() => setAcceptTerms((prev) => !prev)}
              />
              <div className="d-flex gap-2 align-items-center">
                <div className="fs-4 fw-600">
                  {formatCurrency(getTotalFare())}
                </div>
                <AppButton
                  btnText={formattedMessage('confirm_booking')}
                  disabled={!acceptTerms}
                  className="make-payment-btn"
                  onClick={() => handleConfirmBooking('book')}
                />
                {/* {rePriceResponse.holdsupported === true && (
                  <AppButton
                    btnText="Hold booking"
                    disabled={!acceptTerms}
                    variant="secondary"
                    onClick={() => handleConfirmBooking('hold')}
                  />
                )} */}
              </div>
            </div>
          </Col>
          <Col lg={3} md={12} sm={12} xs={12}>
            <section className="flight-fare-summary-section">
              <Accordion className="flight-fare-summary-section">
                {searchRequest.origin.split(':').map((sec, index) => {
                  const date = getDateWithHypends(
                    searchRequest.onwarddate.split(':')[index],
                  );
                  const d = `${sec} - ${
                    searchRequest.destination.split(':')[index]
                  } - ${date}`;
                  return (
                    fareSummaryRef.current[d] && (
                      <Accordion.Item key={d} eventKey={`${index}`}>
                        <Accordion.Header>
                          <div className="fw-600 fs-14 d-flex justify-content-between align -items-center flex-1 pe-1">
                            <span>{d}</span>
                            <span>
                              {formatCurrency(
                                fareSummaryRef.current[d].totalFare,
                              )}
                            </span>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="fare-summary_container flex-1">
                            <div className="fare-summary_title d-flex justify-content-between align-items-center">
                              <span>
                                {formattedMessage('fare_summary_caps')}
                              </span>
                              <AppIconButton
                                className="p-0 fs-16"
                                variant="white"
                                onClick={() => setShowNetFare((prev) => !prev)}
                              >
                                {showNetFare ? <IoMdEyeOff /> : <IoMdEye />}
                              </AppIconButton>
                            </div>
                            <div
                              className="fare-summary_table watermarked"
                              data-watermark={getWaterMark()}
                            >
                              <div className="row spacing-0 px-2 py-1 d-flex flex-column gap-2">
                                <div className="d-flex justify-content-between fw-600 mb-2">
                                  <span>Fare/Pax Type</span>
                                  <span>Amount</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <span>Adult:</span>
                                  <span className="fw-500">
                                    {formatCurrency(
                                      fareSummaryRef.current[d].adultBaseFare,
                                    )}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <span>OT Tax:</span>
                                  <span className="fw-500">
                                    {formatCurrency(
                                      fareSummaryRef.current[d].adultOtTax -
                                        fareSummaryRef.current[d].adultKValue -
                                        fareSummaryRef.current[d]
                                          .adultFuelCharge,
                                    )}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <span>K3/AirlineGST:</span>
                                  <span className="fw-500">
                                    {formatCurrency(
                                      fareSummaryRef.current[d].adultKValue,
                                    )}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <span>YQ:</span>
                                  <span className="fw-500">
                                    {formatCurrency(
                                      fareSummaryRef.current[d].adultFuelCharge,
                                    )}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <span>Adult Total:</span>
                                  <span className="fw-600">
                                    {formatCurrency(
                                      fareSummaryRef.current[d].adultTotalFare,
                                    )}
                                  </span>
                                </div>
                              </div>
                              {parseInt(searchRequest.numchildren, 10) > 0 && (
                                <div className="row spacing-0 px-2 py-1 d-flex flex-column gap-2">
                                  <div className="d-flex justify-content-between">
                                    <span>Child:</span>
                                    <span className="fw-500">
                                      {formatCurrency(
                                        fareSummaryRef.current[d].childBaseFare,
                                      )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span> OT Tax:</span>
                                    <span className="fw-500">
                                      {formatCurrency(
                                        fareSummaryRef.current[d]
                                          .childTotalTax -
                                          fareSummaryRef.current[d]
                                            .childFuelCharge,
                                      )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span>YQ:</span>
                                    <span className="fw-500">
                                      {formatCurrency(
                                        fareSummaryRef.current[d]
                                          .childFuelCharge,
                                      )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span>Child Total:</span>
                                    <span className="fw-600">
                                      {formatCurrency(
                                        fareSummaryRef.current[d]
                                          .childTotalFare,
                                      )}
                                    </span>
                                  </div>
                                </div>
                              )}
                              {parseInt(searchRequest.numinfants, 10) > 0 && (
                                <div className="row spacing-0 px-2 py-1 d-flex flex-column gap-2">
                                  <div className="d-flex justify-content-between">
                                    <span>Infant:</span>
                                    <span className="fw-500">
                                      {formatCurrency(
                                        fareSummaryRef.current[d]
                                          .infantBaseFare,
                                      )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span> OT Tax:</span>
                                    <span className="fw-500">
                                      {formatCurrency(
                                        fareSummaryRef.current[d]
                                          .infantTotalTax -
                                          fareSummaryRef.current[d]
                                            .infantFuelCharge,
                                      )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span>YQ:</span>
                                    <span className="fw-500">
                                      {formatCurrency(
                                        fareSummaryRef.current[d]
                                          .infantFuelCharge,
                                      )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span>Infant Total:</span>
                                    <span className="fw-600">
                                      {formatCurrency(
                                        fareSummaryRef.current[d]
                                          .infantTotalFare,
                                      )}
                                    </span>
                                  </div>
                                </div>
                              )}
                              <div className="row spacing-0 px-2 py-1 d-flex flex-column gap-2">
                                <div className="text-center fw-600 fs-14 ">
                                  Total Fare
                                </div>
                                <div className="d-flex justify-content-between">
                                  <span className="fw-500">
                                    {parseInt(searchRequest.numadults, 10)} x{' '}
                                    {formattedMessage('adult')}
                                  </span>
                                  <span className="fw-600">
                                    {formatCurrency(
                                      fareSummaryRef.current[d].adultTotalFare *
                                        parseInt(searchRequest.numadults, 10),
                                    )}
                                  </span>
                                </div>
                                {searchRequest.numchildren > 0 && (
                                  <div className="d-flex justify-content-between">
                                    <span className="fw-500">
                                      {parseInt(searchRequest.numchildren, 10)}{' '}
                                      x child
                                    </span>
                                    <span className="fw-600">
                                      {formatCurrency(
                                        fareSummaryRef.current[d]
                                          .childTotalFare *
                                          parseInt(
                                            searchRequest.numchildren,
                                            10,
                                          ),
                                      )}
                                    </span>
                                  </div>
                                )}
                                {searchRequest.numinfants > 0 && (
                                  <div className="d-flex justify-content-between">
                                    <span className="fw-500">
                                      {parseInt(searchRequest.numinfants, 10)} x{' '}
                                      {formattedMessage('infant')}
                                    </span>
                                    <span className="fw-600">
                                      {formatCurrency(
                                        fareSummaryRef.current[d]
                                          .infantTotalFare *
                                          parseInt(
                                            searchRequest.numinfants,
                                            10,
                                          ),
                                      )}
                                    </span>
                                  </div>
                                )}
                                {fareSummaryRef.current[d].hasSeat && (
                                  <div className="d-flex justify-content-between">
                                    <span className="fw-500">
                                      {formattedMessage('seats_total')}
                                    </span>
                                    <span className="fw-600">
                                      {formatCurrency(
                                        fareSummaryRef.current[d].seatPrice,
                                      )}
                                    </span>
                                  </div>
                                )}
                                {fareSummaryRef.current[d].hasMeal && (
                                  <div className="d-flex justify-content-between">
                                    <span className="fw-500">
                                      {formattedMessage('meal_total')}
                                    </span>
                                    <span className="fw-600">
                                      {formatCurrency(
                                        fareSummaryRef.current[d].mealPrice,
                                      )}
                                    </span>
                                  </div>
                                )}
                                {fareSummaryRef.current[d].hasBaggage && (
                                  <div className="d-flex justify-content-between">
                                    <span className="fw-500">
                                      Baggage Total
                                    </span>
                                    <span className="fw-600">
                                      {formatCurrency(
                                        fareSummaryRef.current[d].baggagePrice,
                                      )}
                                    </span>
                                  </div>
                                )}
                                {fareSummaryRef.current[d].hasSpecialSsr && (
                                  <div className="d-flex justify-content-between">
                                    <span className="fw-500">
                                      {formattedMessage('special_ssr_total')}
                                    </span>
                                    <span className="fw-600">
                                      {formatCurrency(
                                        fareSummaryRef.current[d]
                                          .specialSsrPrice,
                                      )}
                                    </span>
                                  </div>
                                )}
                                <div className="d-flex justify-content-between">
                                  <span className="fw-500">
                                    Handling Charges(+)
                                  </span>
                                  <span className="fw-600">
                                    {formatCurrency(
                                      fareSummaryRef.current[d].handlingCharges,
                                    )}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <span className="fw-500">GST</span>
                                  <span className="fw-600">
                                    {formatCurrency(
                                      fareSummaryRef.current[d].gst,
                                    )}
                                  </span>
                                </div>
                                {hasTravelInsurance && (
                                  <div className="d-flex justify-content-between">
                                    <span className="fw-500">Insurance</span>
                                    <span className="fw-600">
                                      {formatCurrency(
                                        eligiblePaxForTravelInsurance * 200,
                                      )}
                                    </span>
                                  </div>
                                )}
                              </div>
                              {showNetFare && (
                                <div className="row spacing-0 d-flex flex-column gap-2 px-2 py-1">
                                  <div className="d-flex justify-content-between">
                                    <span className="fw-500">Markup</span>
                                    <span className="fw-600">
                                      {formatCurrency(
                                        fareSummaryRef.current[d].markUp,
                                      )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span className="fw-500">Discount(-)</span>
                                    <span className="fw-600">
                                      {formatCurrency(
                                        fareSummaryRef.current[d].discount,
                                      )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span className="fw-500">PLB(-)</span>
                                    <span className="fw-600">
                                      {formatCurrency(
                                        fareSummaryRef.current[d].plbEarned,
                                      )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span className="fw-500">TDS(+)</span>
                                    <span className="fw-600">
                                      {formatCurrency(
                                        fareSummaryRef.current[d].tds,
                                      )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span className="fw-500">
                                      Total Payable
                                    </span>
                                    <span className="fw-600">
                                      {formatCurrency(
                                        fareSummaryRef.current[d]
                                          .totalAmountToShow,
                                      )}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between">
                                    <span className="fw-500">
                                      Commission Earned
                                    </span>
                                    <span className="fw-600">
                                      {formatCurrency(
                                        fareSummaryRef.current[d].discount +
                                          fareSummaryRef.current[d].plbEarned,
                                      )}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div
                              className="fare-summary_footer watermarked"
                              data-watermark={getWaterMark()}
                            >
                              <div className="row spacing-0">
                                <span className="col fare-summary_footer_title">
                                  {formattedMessage('total_fare')}
                                </span>
                                <span className="col fare-summary_footer_value d-flex flex-column">
                                  <span>
                                    {formatCurrency(
                                      fareSummaryRef.current[d].totalFare,
                                    )}
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    )
                  );
                })}
              </Accordion>
              <div
                className="fare-summary_footer watermarked mt-2"
                data-watermark={getWaterMark()}
              >
                <div className="row spacing-0">
                  <span className="col fare-summary_footer_title">
                    Total Amount
                  </span>
                  <span className="col fare-summary_footer_value d-flex flex-column">
                    <span>{formatCurrency(getTotalFare())}</span>
                  </span>
                </div>
              </div>
              {/* <div className="flight-booking-page_apply-markup mt-3 p-3 d-flex flex-column gap-2">
                <div className="text-center fs-14 fw-600">
                  {formattedMessage('apply_markup')}
                </div>
                {tempMarkupList.map(
                  (pax, index) =>
                    pax.Type !== 'Infant' && (
                      <div key={index} className="my-2">
                        <AppTextInput
                          label={`Markup For ${pax.Type} ${
                            pax.Type === 'Child'
                              ? index +
                                1 -
                                parseInt(searchRequest.numadults, 10)
                              : index + 1
                          }`}
                          value={pax.tax_amount}
                          className="w-100"
                          name="tax_amount"
                          placeholderText=""
                          onChange={(event) =>
                            handleAddMarkupForPax(event, index)
                          }
                        />
                      </div>
                    ),
                )}
                <AppTextInput
                  vaue={appliedMarkup}
                  onChange={(d) => setAppliedMarkup(d)}
                  placeholderText={formattedMessage('mark_up')}
                />
                <AppButton
                  btnText={formattedMessage('apply_btn')}
                  className="fs-12 white-color"
                  variant="select"
                  onClick={handleMarkupAddition}
                />
              </div> */}
            </section>
          </Col>
        </Row>
      </section>
      {isOpenFareRulesDialog && (
        <AppSidebar
          sidebarTitle={formattedMessage('fare_rules_btn')}
          animatedClass="slide-from-right-animation"
          onHideSidebar={() => setIsOpenFareRulesDialog(false)}
          className="overflow-auto flight-details-sidebar"
        >
          <div
            dangerouslySetInnerHTML={{ __html: fareRulesHtml }}
            style={{ overflow: 'auto' }}
            className="fare-rules-tabel"
          />
        </AppSidebar>
      )}
      {showSeatMap && (
        <AppSidebar
          className="overflow-auto flight-details-sidebar p-0"
          sidebarTitle="Seat selection"
          animatedClass="slide-from-right-animation"
          onHideSidebar={() => setShowSeatMap(false)}
        >
          {Object.keys(flightLegsWithSeatsRef.current).length > 0 ? (
            <section className="seat-selection-section">
              <div className="seat-sectors-row d-flex overflow-auto">
                {Object.keys(flightLegsWithSeatsRef.current).map((sector) => (
                  <div
                    key={sector}
                    className={`seat-sector ${
                      seatSelectionSector === sector ? 'active-seat-sector' : ''
                    }`}
                    onClick={() => setSeatSelectionSector(sector)}
                  >
                    {getSectorWithTripNumber(sector)}
                  </div>
                ))}
              </div>
              <div className="separator" />
              {Object.keys(userSelectedSsrRows).length > 0 &&
                Object.keys(flightLegsWithSeatsRef.current).map((sector) => {
                  const sectorSeats = flightLegsWithSeatsRef.current[sector]
                    ? flightLegsWithSeatsRef.current[sector].seats
                    : {};
                  const seatLetters = flightLegsWithSeatsRef.current[sector]
                    ? flightLegsWithSeatsRef.current[sector].seatLetterArray
                    : [];
                  const seatNumbers = flightLegsWithSeatsRef.current[sector]
                    ? flightLegsWithSeatsRef.current[sector].seatDigitArray
                    : [];
                  return (
                    userSelectedSsrRows[sector] &&
                    seatSelectionSector === sector && (
                      <div
                        key={sector}
                        className="d-flex flex-sm-row flex-column"
                      >
                        <div className="d-flex flex-sm-column flex-row travellers-info overflow-auto gap-1">
                          {userSelectedSsrRows[sector].seatRows &&
                            userSelectedSsrRows[sector].seatRows.map(
                              (ssrRow, index) =>
                                ssrRow.paxtype.toLowerCase() !== 'infant' && (
                                  <div
                                    className={`traveller-name ${
                                      activeSeatIndex === index &&
                                      'current-traveller-seat-selection'
                                    }`}
                                    key={index}
                                    onClick={() => setActiveSeatIndex(index)}
                                  >
                                    {getSelectedSeat(ssrRow, index, sector)}
                                  </div>
                                ),
                            )}
                        </div>
                        <div className="flight-seat-map d-flex justify-content-center align-items-center flex-1">
                          <div className="flight-seat-map_container">
                            <div className="flight-seat-map_cockpit">
                              <img src="/images/others/cockpit.svg" alt="" />
                            </div>
                            <div className="flight-seat-map_layout">
                              {Object.keys(sectorSeats).map(
                                (seatRow, seatRowIndex) => (
                                  <div
                                    key={seatRow}
                                    className="d-flex position-relative"
                                  >
                                    <div
                                      className="flight-seat-map_row-designator_left-number"
                                      style={{
                                        marginTop:
                                          seatRowIndex === 0 ? '32px' : '',
                                      }}
                                    >
                                      {seatNumbers[seatRowIndex]}
                                    </div>
                                    <div
                                      className="flight-seat-map_row-designator_right-number"
                                      style={{
                                        marginTop:
                                          seatRowIndex === 0 ? '32px' : '',
                                      }}
                                    >
                                      {seatNumbers[seatRowIndex]}
                                    </div>

                                    {sectorSeats[seatRow].map((seat, index) => (
                                      <div
                                        key={index}
                                        className="d-flex flex-column align-items-center "
                                      >
                                        {seatRowIndex === 0 && (
                                          <div
                                            className={`flight-seat-map_row-designator ${
                                              seat.additionalinfo.indexOf(
                                                'margin-left',
                                              ) > -1
                                                ? 'flight-seat-map_row-designator_aisle-space'
                                                : ''
                                            } `}
                                          >
                                            {seatLetters[index]}
                                          </div>
                                        )}
                                        <div
                                          className={`flight-seat-map_seat ${
                                            seat.additionalinfo.indexOf(
                                              'margin-left',
                                            ) > -1
                                              ? 'flight-seat-map_aisle-space'
                                              : ''
                                          } ${
                                            seat.additionalinfo
                                              .toLowerCase()
                                              .indexOf('exitrow') > -1
                                              ? 'flight-seat-map_exit-row'
                                              : ''
                                          } ${
                                            seat.additionalinfo.indexOf(
                                              'no-seat',
                                            ) > -1
                                              ? 'flight-seat-map_empty-space'
                                              : ''
                                          } ${
                                            seat.seatstatus
                                              .toLowerCase()
                                              .indexOf('open') === -1
                                              ? 'flight-seat-map_booked-seat'
                                              : ''
                                          } ${
                                            userSelectedSsrRows[
                                              sector
                                            ].seatRows.find(
                                              (s) =>
                                                s.ssrcode ===
                                                seat.seatdesignator,
                                            )
                                              ? 'flight-seat-map_selected-seat'
                                              : ''
                                          } `}
                                        >
                                          {seat.additionalinfo.indexOf(
                                            'no-seat',
                                          ) > -1 ? (
                                            ''
                                          ) : (
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={
                                                <Tooltip id="seat-info-tooltip">
                                                  <div className="fs-10 d-flex flex-column">
                                                    {getSeatToolTipText(seat)}
                                                  </div>
                                                </Tooltip>
                                              }
                                            >
                                              <div
                                                className="seat-text"
                                                onClick={() =>
                                                  handleSeatSelection(
                                                    seat,
                                                    sector,
                                                  )
                                                }
                                              >
                                                {getDesignatorForSeat(seat)}
                                              </div>
                                            </OverlayTrigger>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                ),
                              )}
                            </div>
                            {/* <div className="flight-seat-map_cockpit">
                           <img src="/images/others/tailgate.svg" alt="" />
                         </div> */}
                          </div>
                        </div>
                      </div>
                    )
                  );
                })}
            </section>
          ) : (
            <div className="text-center">
              Seat map is not available at the moment
            </div>
          )}
        </AppSidebar>
      )}
      {showMeals && (
        <AppSidebar
          sidebarTitle={formattedMessage('meals')}
          className="overflow-auto flight-details-sidebar p-0 "
          animatedClass="slide-from-right-animation"
          onHideSidebar={() => setShowMeals(false)}
          showFooter
          footerBtnText="Done"
          onFooterClick={() => setShowMeals(false)}
        >
          {Object.keys(flightLegsWithMealRef.current).length > 0 ? (
            <>
              <div className="meal-sectors-row d-flex overflow-auto">
                {Object.keys(flightLegsWithMealRef.current).map((sector) => (
                  <div
                    key={sector}
                    className={`meal-sector ${
                      mealSelectionSector === sector ? 'active-meal-sector' : ''
                    }`}
                    onClick={() => setMealSelectionSector(sector)}
                  >
                    {getSectorWithTripNumber(sector)}
                  </div>
                ))}
              </div>
              <div className="separator" />
              {Object.keys(flightLegsWithMealRef.current).map((sector) => {
                const mealsList = flightLegsWithMealRef.current[sector];
                const userMealRows =
                  userSelectedSsrRows[sector]?.mealRows || [];
                return (
                  mealSelectionSector === sector && (
                    <div
                      key={sector}
                      className="d-flex flex-sm-row flex-column"
                    >
                      <div className="d-flex flex-sm-column flex-row travellers-info overflow-auto gap-1">
                        {travellers.map(
                          (traveller, index) =>
                            traveller.type.toLowerCase() !== 'infant' && (
                              <div
                                className={`traveller-name ${
                                  activeMealIndex === index &&
                                  'current-traveller-seat-selection'
                                }`}
                                key={index}
                                onClick={() => setActiveMealIndex(index)}
                              >
                                {traveller.first_name !== ''
                                  ? `${traveller.title} ${traveller.first_name} ${traveller.last_name}`
                                  : `Traveller ${index + 1}`}
                                <small className="traveller-name__subheading">
                                  {getSelectedMeals(userMealRows, index)}
                                </small>
                              </div>
                            ),
                        )}
                      </div>
                      <div className="separator" />
                      <div className="d-flex flex-1 gap-2 p-3 flex-column">
                        {mealsList.map((meal, index) => (
                          <div
                            key={`${meal.ssrcode}_${index}`}
                            className="ssr-card p-2 mb-2"
                            style={{ width: 'auto' }}
                          >
                            <div>
                              <img
                                className="meal-image"
                                src={meal.imageurl}
                                alt={meal.ssrname}
                              />
                            </div>
                            <div className="ps-3 pe-3 w-100 d-flex flex-column">
                              <div className="flex-1">
                                <p className="ssr-card__meal-name">
                                  {meal.ssrname}
                                </p>
                                <p className="ssr-card__meal-description">
                                  {meal.Desc}
                                </p>
                              </div>
                              <div className="d-flex justify-content-between align-items-center">
                                <p className="ssr-card__meal-name">
                                  {formatCurrency(meal.chargeableamount)}
                                </p>
                                {userMealRows[activeMealIndex].ssrcode ===
                                meal.ssrcode ? (
                                  <AppButton
                                    variant="outlined"
                                    className="ssr-card__add-btn"
                                    btnText={formattedMessage('remove_btn')}
                                    onClick={() =>
                                      handleRemoveMeal(
                                        meal,
                                        index,
                                        `${meal.origin} - ${meal.destination}`,
                                      )
                                    }
                                  />
                                ) : (
                                  <AppButton
                                    className="ssr-card__add-btn"
                                    btnText={formattedMessage('add_btn')}
                                    onClick={() => handleAddMeal(meal, sector)}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
                );
              })}
            </>
          ) : (
            <div className="text-center p-2">
              Meals are not available at the moment
            </div>
          )}
        </AppSidebar>
      )}
      {showBaggage && (
        <AppSidebar
          sidebarTitle={formattedMessage('baggage')}
          className="overflow-auto flight-details-sidebar p-0"
          animatedClass="slide-from-right-animation"
          onHideSidebar={() => setShowBaggage(false)}
          showFooter
          footerBtnText="Done"
          onFooterClick={() => setShowBaggage(false)}
        >
          <div className="baggage-sectors-row d-flex overflow-auto">
            {Object.keys(flightLegsWithBaggageRef.current).map((sector) => (
              <div
                key={sector}
                className={`baggage-sector ${
                  baggageSelectionSector === sector
                    ? 'active-baggage-sector'
                    : ''
                }`}
                onClick={() => setBaggageSelectionSector(sector)}
              >
                {getSectorWithTripNumber(sector)}
              </div>
            ))}
          </div>
          <div className="separator" />
          {Object.keys(flightLegsWithBaggageRef.current).length === 0 && (
            <div className="p-3">
              {formattedMessage('baggage_not_available')}.
            </div>
          )}
          {Object.keys(flightLegsWithBaggageRef.current).map((sector) => {
            const baggageList = flightLegsWithBaggageRef.current[sector];
            const userBaggageRows = userSelectedSsrRows[sector].baggageRows;
            return (
              baggageSelectionSector === sector && (
                <div key={sector} className="d-flex flex-sm-row flex-column">
                  <div className="d-flex flex-sm-column flex-row travellers-info overflow-auto gap-1">
                    {travellers.map(
                      (traveller, index) =>
                        traveller.type.toLowerCase() !== 'infant' && (
                          <div
                            className={`traveller-name ${
                              activeBagIndex === index && 'active-traveller'
                            }`}
                            key={index}
                            onClick={() => setActiveBagIndex(index)}
                          >
                            {traveller.first_name !== ''
                              ? `${traveller.title} ${traveller.first_name} ${traveller.last_name}`
                              : `Traveller ${index + 1}`}
                            <small className="traveller-name__subheading">
                              {getSelectedBaggage(userBaggageRows, index)}
                            </small>
                          </div>
                        ),
                    )}
                  </div>
                  <div className="separator" />
                  <div className="d-flex flex-column gap-1 flex-1 p-1">
                    {baggageList.map((baggage, index) => (
                      <div
                        key={`${baggage.ssrcode}_${index}`}
                        className="ssr-card p-2 mb-2"
                        style={{ width: 'auto' }}
                      >
                        <div>
                          <img
                            className="meal-image"
                            src={baggage.imageurl}
                            alt={baggage.ssrname}
                          />
                        </div>
                        <div className="ps-3 pe-3 w-100 d-flex flex-column">
                          <div className="flex-1">
                            <p className="ssr-card__meal-name">
                              {baggage.ssrname}
                            </p>
                            <p className="ssr-card__meal-description">
                              {baggage.Desc === 'internationalconnections' ? (
                                <div>
                                  <span>
                                    {formattedMessage('baggage_warn')}.
                                  </span>
                                  <AppLink
                                    linkText={formattedMessage(
                                      'terms_conditions',
                                    )}
                                    isLink={false}
                                    onClick={handleTermsConditions}
                                  />
                                </div>
                              ) : (
                                baggage.Desc
                              )}
                            </p>
                          </div>
                          <div className="d-flex justify-content-between align-items-center">
                            <p className="ssr-card__meal-name">
                              {formatCurrency(baggage.chargeableamount)}
                            </p>
                            {userBaggageRows[activeBagIndex].ssrcode ===
                            baggage.ssrcode ? (
                              <AppButton
                                variant="outlined"
                                className="ssr-card__add-btn"
                                btnText={formattedMessage('remove_btn')}
                                onClick={() =>
                                  handelRemoveBaggage(baggage, index, sector)
                                }
                              />
                            ) : (
                              <AppButton
                                className="ssr-card__add-btn"
                                btnText={formattedMessage('add_btn')}
                                onClick={() =>
                                  handleAddBaggage(baggage, sector)
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )
            );
          })}
        </AppSidebar>
      )}
      {showSpecialSsr && (
        <AppSidebar
          sidebarTitle={formattedMessage('special_ssr')}
          className="overflow-auto flight-details-sidebar p-0"
          animatedClass="slide-from-right-animation"
          showFooter
          show={showSpecialSsr}
          onHideSidebar={() => setShowSpecialSsr(false)}
          keyboard={false}
          footerBtnText="Done"
          onFooterClick={() => setShowSpecialSsr(false)}
        >
          {Object.keys(flightLegsWithSpecialSsr.current).length > 0 ? (
            <>
              <div className="baggage-sectors-row d-flex">
                {Object.keys(flightLegsWithSpecialSsr.current).map((sector) => (
                  <div
                    key={sector}
                    className={`baggage-sector ${
                      specialSsrSelectionSector === sector
                        ? 'active-baggage-sector'
                        : ''
                    }`}
                    onClick={() => setSpecialSsrSelectionSector(sector)}
                  >
                    {getSectorWithTripNumber(sector)}
                  </div>
                ))}
              </div>
              <div className="separator" />
              {Object.keys(flightLegsWithSpecialSsr.current).map((sector) => {
                const allSpecialSsr = flightLegsWithSpecialSsr.current[sector];
                const userSpecialSsrRows =
                  userSelectedSsrRows[sector]?.specialSsrRows || [];
                return (
                  specialSsrSelectionSector === sector && (
                    <div
                      key={sector}
                      className="d-flex flex-sm-row flex-column"
                    >
                      <div className="d-flex flex-column gap-1 travellers-info ">
                        {travellers.map(
                          (traveller, index) =>
                            traveller.type.toLowerCase() !== 'infant' && (
                              <div
                                className={`traveller-name ${
                                  activeSsrIndex === index && 'active-traveller'
                                }`}
                                key={index}
                                onClick={() => setActiveSsrIndex(index)}
                              >
                                {traveller.first_name !== ''
                                  ? `${traveller.title} ${traveller.first_name} ${traveller.last_name}`
                                  : `Traveller ${index + 1}`}
                                <small className="traveller-name__subheading">
                                  {getSelectedSpecailSsr(
                                    userSpecialSsrRows,
                                    index,
                                  )}
                                </small>
                              </div>
                            ),
                        )}
                      </div>
                      <div className="separator" />
                      <div className="d-flex flex-column gap-1 flex-1 justify-content-between">
                        {allSpecialSsr.map((specialSsr, index) => (
                          <div
                            key={`${specialSsr.ssrcode}_${index}`}
                            className="ssr-card p-2 mb-2"
                            style={{ width: 'auto' }}
                          >
                            <div>
                              <img
                                className="meal-image"
                                src={specialSsr.imageurl}
                                alt={specialSsr.ssrname}
                              />
                            </div>
                            <div className="ps-3 pe-3 w-100 d-flex flex-column">
                              <div className="flex-1">
                                <p className="ssr-card__meal-name">
                                  {specialSsr.ssrname}
                                </p>
                                <p className="ssr-card__meal-description">
                                  {specialSsr.Desc}
                                </p>
                              </div>
                              <div className="d-flex justify-content-between align-items-center">
                                <p className="ssr-card__meal-name">
                                  {formatCurrency(specialSsr.chargeableamount)}
                                </p>
                                {userSpecialSsrRows[activeSsrIndex].ssrcode ===
                                specialSsr.ssrcode ? (
                                  <AppButton
                                    variant="outlined"
                                    className="ssr-card__add-btn"
                                    btnText={formattedMessage('remove_btn')}
                                    onClick={() =>
                                      handelRemoveSpecialSsr(sector)
                                    }
                                  />
                                ) : (
                                  <AppButton
                                    className="ssr-card__add-btn"
                                    btnText={formattedMessage('add_btn')}
                                    onClick={() =>
                                      handleAddSpecialSsr(specialSsr, sector)
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
                );
              })}
            </>
          ) : (
            <div className="text-center p-2">
              Special SSR are not available at the moment
            </div>
          )}
        </AppSidebar>
      )}
      {showConfirmationDialog && (
        <Modal
          className="app-modal booking-confirm-modal"
          size="lg"
          show={showConfirmationDialog}
          onHide={handleConfirmationDialogClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title>{formattedMessage('reconfirm_title')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Accordion>
              {searchRequest.origin.split(':').map((d, index) => {
                const date = getDateWithHypends(
                  searchRequest.onwarddate.split(':')[index],
                );
                const sec = `${d} - ${
                  searchRequest.destination.split(':')[index]
                } - ${date}`;
                return (
                  <Accordion.Item key={sec} eventKey={`${index}`}>
                    <Accordion.Header>
                      <div className="d-flex flex-1 justify-content-between align-items-center pe-2 flex-sm-row flex-column">
                        <div className="fs-16 fw-600" key={d}>{`${
                          searchRequest.originlocations
                            .split(':')
                            [index].split(',')[0]
                        } (${d}) -> ${
                          searchRequest.destinationlocations
                            .split(':')
                            [index].split(',')[0]
                        } (${
                          searchRequest.destination.split(':')[index]
                        }) | ${formatDate(
                          getNewDate(getOnwardDate(index)),
                          DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                        )}`}</div>
                        <AppLink
                          linkText="Fare Rules"
                          variant="secondary"
                          onClick={() =>
                            handleOpenFareRules(selectedFareKeys[sec])
                          }
                        />
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <SelectedFlightDetails
                        selectedFlight={selectedFlight[sec]}
                        searchRequest={getSearchRequestForSector(sec)}
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
            <div className="px-3">
              <h6>Travellers</h6>
              <table className="table table-bordered fs-14">
                <thead>
                  <tr>
                    <th>Guest Name</th>
                    <th>Segment</th>
                    <th>Seat No.</th>
                    <th>Excess Baggage</th>
                    <th>Meal</th>
                    <th>Other SSR</th>
                  </tr>
                </thead>
                <tbody>
                  {travellers.map((traveller, index) =>
                    flightSectorsRef.current.map((sector, sectorIndex) => (
                      <React.Fragment key={sectorIndex}>
                        {sectorIndex === 0 && (
                          <tr key={index}>
                            <td
                              rowSpan={flightSectorsRef.current.length}
                            >{`${traveller.title} ${traveller.first_name} ${traveller.last_name}`}</td>
                            <td>{getSectorWithTripNumber(sector)}</td>
                            <td>{getSeatNo(sector, index)}</td>
                            <td>{getExcessBaggage(sector, index)}</td>
                            <td>{getMeal(sector, index)}</td>
                            <td>{getOtherSsr(sector, index)}</td>
                          </tr>
                        )}
                        {sectorIndex !== 0 && (
                          <tr>
                            <td>{getSectorWithTripNumber(sector)}</td>
                            <td>{getSeatNo(sector, index)}</td>
                            <td>{getExcessBaggage(sector, index)}</td>
                            <td>{getMeal(sector, index)}</td>
                            <td>{getOtherSsr(sector, index)}</td>
                          </tr>
                        )}
                      </React.Fragment>
                    )),
                  )}
                </tbody>
              </table>
            </div>
            <div className="p-3">
              <div className="d-flex justify-content-between">
                <div className="d-flex flex-column">
                  <span className="secondary-text">
                    {formattedMessage('contact_email')}
                  </span>
                  <span>{leademail}</span>
                </div>
                <div className="d-flex flex-column">
                  <span className="secondary-text">
                    {formattedMessage('contact_mobile')}
                  </span>
                  <span>{leadmobile}</span>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between mt-3 p-3">
              <span className="secondary-text">
                {formattedMessage('total_fare')}
              </span>
              <span className="fare-summary">
                {formatCurrency(getTotalFare())}
              </span>
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-between">
            <div className="d-flex flex-column align-items-center">
              <span className="fs-5">{formattedMessage('wallet_balance')}</span>
              <span className="fs-4 fw-500">
                {formatCurrency(walletBalanceRef.current)}
              </span>
            </div>
            <div>
              <AppButton
                variant="outlined"
                btnText={formattedMessage('cancel_btn')}
                className="me-2"
                onClick={handleConfirmationDialogClose}
              />
              <AppButton
                btnText={formattedMessage('confirm_btn')}
                onClick={handleBook}
              />
            </div>
          </Modal.Footer>
        </Modal>
      )}
      {showConfirmHoldDialog && (
        <Modal
          className="app-modal booking-confirm-modal"
          size="lg"
          show={showConfirmHoldDialog}
          onHide={handleConfirmHoldDialogClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title>Confirm Hold</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="px-3">
              <h6>{formattedMessage('travellers')}</h6>
              {travellers.map((traveller, index) => (
                <div key={index}>
                  <div>{`${index + 1}) ${traveller.title} ${
                    traveller.first_name
                  } ${traveller.last_name}`}</div>
                  <div className="mb-3 secondary-text fw-500">
                    {getUserSsr(traveller, index)}
                  </div>
                </div>
              ))}
            </div>
            <div className="p-3">
              <div className="d-flex justify-content-between">
                <div className="d-flex flex-column">
                  <span className="secondary-text">
                    {formattedMessage('contact_email')}
                  </span>
                  <span>{leademail}</span>
                </div>
                <div className="d-flex flex-column">
                  <span className="secondary-text">
                    {formattedMessage('contact_mobile')}
                  </span>
                  <span>{leadmobile}</span>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between mt-3 p-3">
              <span className="secondary-text">
                {formattedMessage('total_fare')}
              </span>
              <span className="fare-summary">
                {formatCurrency(fareSummaryRef.current.totalFare)}
              </span>
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-between">
            <div className="d-flex flex-column align-items-center">
              <span className="fs-5">{formattedMessage('wallet_balance')}</span>
              <span className="fs-4 fw-500">
                {formatCurrency(walletBalanceRef.current)}
              </span>
            </div>
            <div>
              <AppButton
                variant="outlined"
                btnText={formattedMessage('cancel_btn')}
                className="me-2"
                onClick={handleConfirmHoldDialogClose}
              />
              <AppButton btnText="Confirm Hold" onClick={handleHold} />
            </div>
          </Modal.Footer>
        </Modal>
      )}
      {showSpecialAssistance && (
        <Modal
          className="app-modal booking-confirm-modal"
          size="md"
          show={showSpecialAssistance}
          onHide={setShowSpecialAssistance}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {formattedMessage('requires_special_assistance_for')}{' '}
              {selectedTravellerRef.current.title}{' '}
              {selectedTravellerRef.current.first_name}{' '}
              {selectedTravellerRef.current.last_name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="separator" />
            <div className="baggage-sectors-row d-flex">
              {Object.keys(FlightLegsWithSpecialAssistanceRef.current).map(
                (sector) => (
                  <div
                    key={sector}
                    className={`baggage-sector ${
                      specialAssistanceSelectionSector === sector
                        ? 'active-baggage-sector'
                        : ''
                    }`}
                    onClick={() => setSpecialAssistanceSelectionSector(sector)}
                  >
                    {sector}
                  </div>
                ),
              )}
            </div>
            <div className="separator" />
            {Object.keys(FlightLegsWithSpecialAssistanceRef.current).map(
              (sector) => {
                const specialAssistanceList =
                  FlightLegsWithSpecialAssistanceRef.current[sector];
                return (
                  specialAssistanceSelectionSector === sector && (
                    <div key={sector} className="p-3">
                      {specialAssistanceList.map((sa) => (
                        <div
                          key={sa.ssrcode}
                          className="py-2 d-flex justify-content-between"
                        >
                          <span>{sa.ssrname}</span>
                          <input
                            type="radio"
                            name={`${sector}_specialSsr`}
                            id={sa.ssrcode}
                            checked={
                              wheelChairSsr &&
                              wheelChairSsr[sector] &&
                              wheelChairSsr[sector][
                                selectedSpecialAssistanceIndexRef.current
                              ] &&
                              wheelChairSsr[sector][
                                selectedSpecialAssistanceIndexRef.current
                              ].ssrcode === sa.ssrcode
                            }
                            onChange={(event) =>
                              handleSAChange(
                                event,
                                sa,
                                specialAssistanceSelectionSector,
                              )
                            }
                          />
                        </div>
                      ))}
                    </div>
                  )
                );
              },
            )}
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            <AppButton
              variant="secondary"
              onClick={handleClearSsr}
              btnText={formattedMessage('remove_btn')}
            />
            <AppButton
              onClick={() => handleAddWheelChariSsr()}
              btnText={formattedMessage('add_btn')}
            />
          </Modal.Footer>
        </Modal>
      )}
      {showPostBookingPopup && (
        <Modal
          show={showPostBookingPopup}
          onHide={handleClosePostBookingPopup}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title>Flight Booking</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center fs-16 fw-600 mb-2">
              Here are the booking details for your Trips
            </div>
            {flightBookingResponse.length > 0 && (
              <table className="w-100 fs-14 table table-bordered">
                <thead>
                  <tr>
                    <th>Sector</th>
                    <th>Booking ID</th>
                    <th>View Ticket</th>
                  </tr>
                </thead>
                <tbody>
                  {flightBookingResponse.map((sec) => (
                    <tr key={sec.sector}>
                      <td>{sec.sector}</td>
                      <td>{sec.fbid}</td>
                      {sec.status === 'success' ? (
                        <td>
                          <AppLink
                            linkText="View Ticket"
                            onClick={() => handleNavigateToTicketPage(sec.fbid)}
                          />
                        </td>
                      ) : (
                        <td />
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Modal.Body>
          <Modal.Footer>
            <AppButton btnText="Go to home" onClick={() => navigate('/')} />
          </Modal.Footer>
        </Modal>
      )}
      {showSelectPaxModal && (
        <AppSidebar
          className="overflow-auto flight-details-sidebar"
          sidebarTitle="Choose Passenger"
          animatedClass="slide-from-right-animation"
          onHideSidebar={() => setShowSelectPaxModal(false)}
        >
          <div>
            <div className="p-4 pb-2 d-flex gap-3">
              <div className="w-50">
                <AppTextInput
                  placeholderText="Please enter name"
                  label="Enter name"
                  required
                  name="profileName"
                  id="profileName"
                  onChange={(e) => setProfileName(e.target.value)}
                  value={profileName}
                  errorText={alert && 'Please enter name'}
                />
              </div>

              <AppButton onClick={handleSearchCustomer} btnText="Search" />
            </div>

            {customers.length > 0 && (
              <>
                <div className="overflow-auto m-2">
                  <table className="table table-bordered fs-14 mt-2">
                    <thead>
                      <tr>
                        <th>FirstName</th>
                        <th>LastName</th>
                        <th>Gender</th>
                        <th>Mobile</th>
                        <th>Email</th>
                        <th>Select any one</th>
                      </tr>
                    </thead>
                    {customers.map((pax, index) => (
                      <tbody key={index}>
                        <tr>
                          <td>{pax.FirstName}</td>
                          <td>{pax.LastName}</td>
                          <td>{pax.Gender}</td>
                          <td>{pax.Phone}</td>
                          <td>{pax.Email}</td>
                          <td style={{ textAlign: 'center' }}>
                            <AppButton
                              btnText="Select"
                              variant="outlined"
                              className="h-50"
                              onClick={() => handleSelectCustomer(pax)}
                            />
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </>
            )}
          </div>
        </AppSidebar>
      )}
    </section>
  );
}

export default FlightDomMultiCityBookingPage;
